import { IComboBoxOption, IContextualMenuItem, IDatePickerStrings } from "@fluentui/react";
import { ICity, ICountry, IDepartment } from '@ioip/archivox/lib';
import { Guid, IDictionary } from '@ioip/core/lib';
import { IDataSourceResponse } from '@ioip/procesox/lib';
import { IJSFormV1 } from '@ioip/procesox/lib/projects/IJSForm';
import { IJSPage } from '@ioip/procesox/lib/types/IJSPage';
import { CSSProperties } from 'react';
import { Sede } from '../../classes/shared';
//#region SharePoint

export interface IMemexpoxtaWebPartProps {
  nombre: string;
  icon: string;
  appId: string;
  tenantId: string;
  cssStyles: string;
  headerImage: string;
  title: string;
}

export interface IMemexpoxtaProps {
  nombre?: string;
  match?: any,
  icon?: string;
  appUrl?: string;
  appId?: string;
  tenantId?: string;
  context?: any;
  title?: string;
}

export declare class AadHttpClient {
  fetch(url: string, configuration: AadHttpClientConfiguration, options: IHttpClientOptions): Promise<HttpClientResponse>;
  get(url: string, configuration: AadHttpClientConfiguration, options?: IHttpClientOptions): Promise<HttpClientResponse>;
  post(url: string, configuration: AadHttpClientConfiguration, options: IHttpClientOptions): Promise<HttpClientResponse>;
}

export declare class AadHttpClientConfiguration extends HttpClientConfiguration implements IAadHttpClientConfiguration {
  constructor(flags: IAadHttpClientConfiguration, overrideFlags?: IAadHttpClientConfiguration);
  overrideWith(sourceFlags: IAadHttpClientConfiguration): AadHttpClientConfiguration;
}

export declare class HttpClientConfiguration implements IHttpClientConfiguration {
  constructor(flags: IHttpClientConfiguration, overrideFlags?: IHttpClientConfiguration);
  overrideWith(sourceFlags: IHttpClientConfiguration): HttpClientConfiguration;
  protected initializeFlags(): void;
}

export interface HttpClientResponse {
  arrayBuffer(): Promise<ArrayBuffer>;
  blob(): Promise<Blob>;
  formData(): Promise<FormData>;
  json(): Promise<any>;
  text(): Promise<string>;
  readonly ok: boolean;
}

export declare interface IAadHttpClientConfiguration extends IHttpClientConfiguration {
}

export declare interface IAadHttpClientConfigurations {
  readonly v1: AadHttpClientConfiguration;
}

declare interface IHttpClientConfiguration {
}

export declare interface IHttpClientOptions extends RequestInit {
}

export declare interface AadHttpClient extends RequestInit { }

export declare interface IHttpClientOptions extends RequestInit { }

//#endregion


export class BaseService {
  public clientId: string;
  public serviceUrl: string;
  public context: any;
  public controller: string = '';
  protected _useLoader: boolean = true;
  public showLoader: boolean = true;
  private logStyle: string = 'color: #4CAF50; font-size: 12px; text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;';

  constructor() {
    this.context = $_.context;
    this.clientId = $_.props.appId;
    this.serviceUrl = (window as any).serviceUrl;
  }

  private _isAad(): boolean {
    return this.context !== undefined && (this.context as any).aadHttpClientFactory !== undefined;
  }

  private async getAddClient(): Promise<any> {
    return new Promise<AadHttpClient>(async (resolve, reject) => {
      try {
        //const client = await (this.context as any).aadHttpClientFactory.getClient(this.clientId);
        resolve({
          get: (url: string, config: any, options: any): any => {
            return fetch(url, options);
          },
          post: (url: string, config: any, options: any): any => {
            return fetch(url, {
              ...options,
              method: 'POST'
            });
          },
        } as any);
        //resolve(client as any);
      } catch (ex) {
        reject({
          ExceptionMessage: `Error de comunicación con el servidor. ${(ex as any).message}`
        });
      }
    });
  }

  private async getHttpClient(): Promise<any> {
    return new Promise<AadHttpClient>(async (resolve, reject) => {
      try {
        resolve({
          get: (url: string, config: any, options: any): any => {
            return fetch(url, options)
          },
          post: (url: string, config: any, options: any): any => {
            return fetch(url, {
              ...options,
              method: 'POST'
            });
          },
        } as any);
        //resolve(client as any);
      } catch (ex) {
        reject({
          ExceptionMessage: `Error de comunicación con el servidor. ${(ex as any).message}`
        });
      }
    });
  }

  private _getHttpClientOptions(): IHttpClientOptions {
    const _httpClientOptions: IHttpClientOptions = {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Tenant-Id': $_.props.tenantId,
        'Authorization': 'Bearer dev'
      }
    };
    if (!this._isAad()) {
      _httpClientOptions.credentials = 'include';
    }
    return _httpClientOptions;
  }

  public async getClient(): Promise<AadHttpClient> {
    const client: AadHttpClient = this._isAad() ? await this.getAddClient() : this.getHttpClient() as any;
    return client
  }

  protected _getFormfieldDataSourceAsync(url: string, filters: IDictionary<any>): Promise<any> {

    if (filters !== void 0) {
      const processedFilters: string[] = [];
      for (const filter in filters) {
        if (Object.prototype.hasOwnProperty.call(filters, filter)) {
          const value = filters[ filter ];
          processedFilters.push(`filters[${filter}]=${value}`);
        }
      }
      if (url.indexOf('?') >= 0) {
        url += '&' + processedFilters.join('&');
      } else {
        url += '?' + processedFilters.join('&');
      }
    }

    return this.aadGet<any>(url);
  }

  protected async aadGet<T>(apiUrl: string): Promise<T> {
    return new Promise<any>(async (resolve, reject) => {
      try {
        const isAbsoluteUrl = apiUrl.trim().toLowerCase().startsWith('http')
          || apiUrl.trim().toLowerCase().startsWith('https');
        const client: AadHttpClient = await this.getClient();
        const url = isAbsoluteUrl ? apiUrl : `${this.serviceUrl}/${apiUrl}`;
        const response: HttpClientResponse = await client.get(url, {} as any, this._getHttpClientOptions());
        if (response.ok) {
          resolve(response.json());
        } else {
          const err = await response.json();
          this._writeException(err);
          reject(err);
        }
      } catch (ex) {
        reject({
          ExceptionMessage: `Error de comunicación con el servidor. ${(ex as any).message}`
        });
      }
    });
  }

  protected async aadGetArrayBuffer(apiUrl: string): Promise<Blob> {
    return new Promise<any>(async (resolve, reject) => {
      try {
        const client: AadHttpClient = await this.getClient();
        const url = `${this.serviceUrl}/${apiUrl}`;
        console.log(`%cGET: ${url}`, this.logStyle);
        const response: HttpClientResponse = await client.get(url, {} as any, this._getHttpClientOptions());
        if (response.ok) {
          resolve(response.blob());
        } else {
          const err = await response.json();
          this._writeException(err);
          reject(err);
        }
      } catch (ex) {
        reject({
          ExceptionMessage: `Error de comunicación con el servidor. ${(ex as any).message}`
        });
      }
    });
  }

  protected async aadGetText(apiUrl: string): Promise<string> {
    return new Promise<any>(async (resolve, reject) => {
      try {
        const client: AadHttpClient = await this.getClient();
        const url = `${this.serviceUrl}/${apiUrl}`;
        console.log(`%cGET: ${url}`, this.logStyle);
        const response: HttpClientResponse = await client.get(url, {} as any, this._getHttpClientOptions());
        if (response.ok) {
          resolve(response.text());
        } else {
          const err = await response.json();
          this._writeException(err);
          reject(err);
        }
      } catch (ex) {
        reject({
          ExceptionMessage: `Error de comunicación con el servidor. ${(ex as any).message}`
        });
      }
    });
  }

  protected async aadPost<T>(apiUrl: string, data: any, showLoader: boolean = true): Promise<T> {
    return new Promise<any>(async (resolve, reject) => {
      try {
        const client: AadHttpClient = await this.getClient();
        const options: IHttpClientOptions = {
          ...this._getHttpClientOptions(),
          body: JSON.stringify(data)
        };
        const url = `${this.serviceUrl}/${apiUrl}`;
        console.log(`%cPOST: ${url}`, this.logStyle);
        const response: HttpClientResponse = await client.post(url, {} as any, options);
        if (response.ok) {
          resolve(response.json());
        } else {
          const err = await response.json();
          this._writeException(err);
          reject(err);
        }
      } catch (ex) {
        reject({
          ExceptionMessage: `Error de comunicación con el servidor. ${(ex as any).message}`
        });
      }
    });

  }

  protected async aadPostArrayBuffer<T>(apiUrl: string, data: any, showLoader: boolean = true): Promise<T> {
    return new Promise<any>(async (resolve, reject) => {
      try {
        const client: AadHttpClient = await this.getClient();
        const options: IHttpClientOptions = {
          ...this._getHttpClientOptions(),
          body: JSON.stringify(data)
        };
        const url = `${this.serviceUrl}/${apiUrl}`;
        console.log(`%cPOST: ${url}`, this.logStyle);
        const response: HttpClientResponse = await client.post(url, {} as any, options);
        if (response.ok) {
          resolve(response.blob());
        } else {
          const err = await response.json();
          this._writeException(err);
          reject(err);
        }
      } catch (ex) {
        reject({
          ExceptionMessage: `Error de comunicación con el servidor. ${(ex as any).message}`
        });
      }
    });

  }

  public async aadPut<T>(apiUrl: string, data: any, showLoader: boolean = true): Promise<T> {
    return new Promise<any>(async (resolve, reject) => {
      try {
        const client: AadHttpClient = await this.getClient();
        const options: IHttpClientOptions = {
          ...this._getHttpClientOptions(),
          body: JSON.stringify(data),
          method: 'PUT'
        };
        const url = `${this.serviceUrl}/${apiUrl}`;
        console.log(`%cPUT: ${url}`, this.logStyle);
        const response: HttpClientResponse = await client.fetch(url, {} as any, options);
        if (response.ok) {
          resolve(response.json());
        } else {
          const err = await response.json();
          this._writeException(err);
          reject(err);
        }
      } catch (ex) {
        reject({
          ExceptionMessage: `Error de comunicación con el servidor. ${(ex as any).message}`
        });
      }
    });

  }

  public async aadDelete(apiUrl: string, data?: any): Promise<void> {
    return new Promise<void>(async (resolve, reject) => {
      try {
        const client: AadHttpClient = await this.getClient();
        const options: IHttpClientOptions = {
          ...this._getHttpClientOptions(),
          method: 'DELETE'
        };
        if (data) {
          options.body = JSON.stringify(data);
        }
        const url = `${this.serviceUrl}/${apiUrl}`;
        console.log(`%cDELETE: ${url}`, this.logStyle);
        const response: HttpClientResponse = await client.fetch(url, {} as any, options);
        if (response.ok) {
          resolve();
        } else {
          const err = await response.json();
          this._writeException(err);
          reject(err);
        }
      } catch (ex) {
        reject({
          ExceptionMessage: `Error de comunicación con el servidor. ${(ex as any).message}`
        });
      }
    });
  }

  public async aadFormData<T>(apiUrl: string, data: any): Promise<T> {
    return new Promise<any>(async (resolve, reject) => {
      try {
        const client: AadHttpClient = await this.getClient();
        const options: IHttpClientOptions = { body: data };
        const response: HttpClientResponse = await client.post(`${this.serviceUrl}/${apiUrl}`, (AadHttpClient as any).configurations.v1, options);
        if (response.ok) {
          resolve(response.json());
        } else {
          const err = await response.json();
          this._writeException(err);
          reject(err);
        }
      } catch (ex) {
        reject({
          ExceptionMessage: `Error de comunicación con el servidor. ${(ex as any).message}`
        });
      }
    });
  }



  protected async shpGet<T>(url: string): Promise<T> {
    const options = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } };
    return new Promise<T>(async (resolve, reject) => {
      const response = await this.context.spHttpClient.get(url, ({} as any), options);
      if (response.ok) {
        resolve(response.json());
      } else {
        const err = await response.json();
        this._writeException(err);
        reject(err);
      }
    });
  }

  protected _writeException(err: any): void {
    console.log(`Message: ${err.Message}`);
    console.log(`ExceptionType: ${err.ExceptionType}`);
    console.log(`ExceptionMessage: ${err.ExceptionMessage}`);
    console.log(`StackTrace: ${err.StackTrace}`);
  }

}

export default interface IApiException {
  Message: string;
}

export function base64blob(b64Data: string, contentType: string, sliceSize?: number): Blob {
  contentType = contentType || '';
  sliceSize = sliceSize || 512;
  var byteCharacters = atob(b64Data);
  var byteArrays = [];
  for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    var slice = byteCharacters.slice(offset, offset + sliceSize);
    var byteNumbers = new Array(slice.length);
    for (var i = 0; i < slice.length; i++) {
      byteNumbers[ i ] = slice.charCodeAt(i);
    }
    var byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }
  var blob = new Blob(byteArrays, { type: contentType });
  return blob;
}

export function fileToBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = error => reject(error);
  });
}

export const MIME_TYPE_PDF = '	application/pdf';
export const MIME_TYPE_WORD_2007_AND_ABOVE = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
export const MIME_TYPE_JPEG = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
export const DEFAULT_COMBOBOX_OPTION: IComboBoxOption[] = [ { key: '0', text: '[-- Seleccione --]' } ];
export const NO_HAY_INFORMACION = 'No hay información para mostrar en este momento';
export const ID_PAIS_COLOMBIA = 43;
export const ID_DEPARTAMENTO_BOGOTA = 5;
export const ID_CIUDAD_BOGOTA = 110;

export class DataTableFilter {
  Start: string;
  Length: string | number | boolean;
}

export class DataTableRequest {
  Start: number;
  Length: number;
  OrderColumn: number;
  SortDirection: string;
  Search: string;
  Filters: DataTableFilter[]

  constructor(start: number, length: number, orderColumn: number, sortDirection: string, search: string, filters?: DataTableFilter[]) {
    this.Start = start;
    this.Length = length;
    this.OrderColumn = orderColumn;
    this.SortDirection = sortDirection;
    this.Search = search;
    this.Filters = filters || [];
  }

}

export class DataTablesResponse {
  Data: any[];
  Draw: number;
  RecordsFiltered: number;
  RecordsTotal: number;
  LastItem: number;
}

export function defaultDataTablesResponse(): DataTablesResponse {
  return {
    Data: [],
    Draw: 0,
    RecordsFiltered: 0,
    RecordsTotal: 0,
    LastItem: 0
  };
}

export const DatePickerStrings: IDatePickerStrings = {
  months: [ 'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre' ],
  shortMonths: [ 'Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic' ],
  days: [ 'Domingo', 'Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes', 'Sábado' ],
  shortDays: [ 'D', 'L', 'M', 'M', 'J', 'V', 'S' ],
  goToToday: 'Ir a hoy',
  prevMonthAriaLabel: 'Ir al mes anterior',
  nextMonthAriaLabel: 'Ir al proximo mes',
  prevYearAriaLabel: 'Ir al año anterior',
  nextYearAriaLabel: 'Ir al proximo año'
};

export interface DropZoneComponentItem {
  Name: string;
  Length: number;
}

export interface IDropZoneFile {
  Name: string;
  Type: string;
  Length: number;
  PreventRemove: boolean;
  Data: any;
  File: File;
}

export const SUPPORTEDNATIVEFILETYPES = ',pdf,jpg,jpeg,png,gif,bmp,webp,svg,mpeg,webm,ogg,wav,txt,mp3';

export const SUPPORTEDSHAREPOINTVIEWERFILETYPES = ',csv,dic,doc,docm,docx,dotm,dotx,pot,potm,potx,pps,ppsm,ppsx,ppt,pptm,pptx,xd,xls,xlsb,xlsx,sltx,eml,msg,vsd,vsdx,rft,odp,ods,odt,ai,pdf,psb,psd,3g2,3gp,asf,bmp,m2ts,m4v,mov,mp3,mp4,mp4v,mts,ts,wmv,gif,jpeg,jpg,jpe,mef,mrw,nef,nrw,orf,pano,pef,png,spm,tif,tiff,xbm,xcf';

export const OFFICEFILETYPES = 'doc,docx,xls,xlsx,ppt,pptx';

export function getFileWithMimeType(file: Blob, extension: string): Blob {

  var file: Blob;

  switch (extension.toLowerCase()) {
    case 'pdf':
      file = new Blob([ file ], { type: $_.const.MimeTypes.Pdf });
      break;
    case 'docx':
      file = new Blob([ file ], { type: $_.const.MimeTypes.Word2007AndAbove });
      break;
    case 'doc':
      file = new Blob([ file ], { type: $_.const.MimeTypes.Word2007AndAbove });
      break;
    case 'xls':
      file = new Blob([ file ], { type: $_.const.MimeTypes.Exce2007AndAbove });
      break;
    case 'xlsx':
      file = new Blob([ file ], { type: $_.const.MimeTypes.Exce2007AndAbove });
      break;
    case 'jpg':
      file = new Blob([ file ], { type: $_.const.MimeTypes.Jpeg });
      break;
    case 'png':
      file = new Blob([ file ], { type: $_.const.MimeTypes.Png });
      break;
    case 'gif':
      file = new Blob([ file ], { type: $_.const.MimeTypes.Gif });
      break;
    case 'bmp':
      file = new Blob([ file ], { type: $_.const.MimeTypes.Bmp });
      break;
    case 'webp':
      file = new Blob([ file ], { type: $_.const.MimeTypes.Webp });
      break;
    case 'svg':
      file = new Blob([ file ], { type: $_.const.MimeTypes.Svg });
      break;
    case 'mid':
      file = new Blob([ file ], { type: $_.const.MimeTypes.Midi });
      break;
    case 'mp3':
    case 'mpeg':
      file = new Blob([ file ], { type: $_.const.MimeTypes.Mpeg });
      break;
    case 'webm':
      file = new Blob([ file ], { type: $_.const.MimeTypes.Webm });
      break;
    case 'ogg':
      file = new Blob([ file ], { type: $_.const.MimeTypes.Ogg });
      break;
    case 'wav':
      file = new Blob([ file ], { type: $_.const.MimeTypes.Wav });
      break;
    case 'txt':
      file = new Blob([ file ], { type: $_.const.MimeTypes.Text });
      break;
  }

  return file;
}

export function showError(errorMessage: string): Promise<void> {
  return new Promise<void>(resolve => {
    alert(errorMessage);
    resolve();
  });
}

export function showConfirmation(title: string, text: string, callback: (() => void) | (() => Promise<void>)): void {
  if ($_.confirmationDialog) {
    $_.confirmationDialog(title, text, callback);
  }
}

export function successToast(text: string): void {
  if ($_.successToast && text) {
    $_.successToast(text);
  }
}

export function showWarnToast(text: string): void {
  if ($_.showWarnToast && text) {
    $_.showWarnToast(text);
  }
}

export interface IConfiguracionSitioSuscripcion {
  ApplicationSiteUrl: string;
  ApplicationSiteRelativeUrl: string;
  GestionSiteUrl: string;
  GestionSiteRelativeUrl: string;
  CentralSiteUrl: string;
  CentralSiteRelativeUrl: string;
  RecordsSiteUrl: string;
  RecordsSiteRelativeUrl: string;
}

export interface Global {
  /**
   * Usuario actual
   */
  errorDialog: (message: string, callback?: () => void) => void;
  confirmationDialog: (title: string, text: string, callback: (() => void) | (() => Promise<void>)) => void;
  successToast: (text: string) => void;
  showWarnToast: (text: string) => void;
  isO365: boolean;
  context: any;
  props: IMemexpoxtaWebPartProps;
  enablePoxta: boolean;
  svc: IAppServices;
  const: {
    DescripcionDocumental: {
      OtroTipoAnexo: number
    };
    MimeTypes: {
      Pdf: string;
      Word2007AndAbove: string;
      Exce2007AndAbove: string;
      PPTX2007AndAbove: string;
      Jpeg: string;
      Png: string;
      Gif: string;
      Bmp: string;
      Webp: string;
      Svg: string;
      Midi: string;
      Mpeg: string;
      Wav: string;
      Webm: string;
      Ogg: string;
      Text: string;
    };
    OrigenDocumentoEscritorio: number;
    OrigenDocumentoScanner: number;
    OrigenDocumentoStrings: IComboBoxOption[];
    TipoDocumentoStrings: IComboBoxOption[];
    TipoIdentificacion: {
      Nit: number;
    },
    TiposFirmaComunicadoInterno: {
      Electronica: boolean;
      Digital: boolean;
      Manuscrita: boolean;
    }
  },
  def: {
    editButton: (callback: () => void) => IContextualMenuItem;
    deleteButton: (callback: () => void) => IContextualMenuItem;
    btn: {
      newButton: (href: string) => IContextualMenuItem;
      exportButton: (callback: () => void) => IContextualMenuItem;
      exportExcel: (service: () => Promise<Blob>, filename: string) => IContextualMenuItem;
      bulkLoad: (callback: () => void) => IContextualMenuItem;
      downloadTemplate: (href: string) => IContextualMenuItem;
      deleteItem: (callback: () => Promise<void>) => IContextualMenuItem;
      editHref: (href: string) => IContextualMenuItem;
    }
  },
  utils: {
    /**
     * Descarga un blob en el equipo del usuaro
     * @param blob Blob a descargar
     * @param filename Nombre del archivo
     * @param mimeType MimeType
     */
    downloadBlob: (blob: Blob, filename: string, mimeType?: string) => void;
    downloadExcel: (blob: Blob, filename: string) => void;
    downloadPdf: (blob: Blob, filename: string) => void;
    downloadService: (service: () => Promise<Blob>, filename: string, mimeType?: string) => void;
    downloadServiceExcel: (service: Promise<Blob>, filename: string) => void;
  },
  isNull: (obj: any) => boolean;
  isNullOrEmpty: (obj: any) => boolean;
  extensions: { [ key: string ]: any };
}

export let $_: Global = {
  errorDialog: undefined,
  confirmationDialog: undefined,
  successToast: undefined,
  showWarnToast: undefined,
  isO365: false,
  context: undefined,
  props: {
    nombre: '',
    icon: '',
    appId: '',
    tenantId: '',
    cssStyles: '',
    headerImage: '',
    title: ''
  },
  enablePoxta: false,
  svc: undefined,
  const: {
    DescripcionDocumental: {
      OtroTipoAnexo: 1
    },
    MimeTypes: {
      Pdf: 'application/pdf',
      Word2007AndAbove: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      Exce2007AndAbove: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      PPTX2007AndAbove: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
      Jpeg: 'image/jpeg',
      Png: 'image/png',
      Gif: 'image/gif',
      Bmp: 'image/bmp',
      Webp: 'image/webp',
      Svg: 'image/svg+xml',
      Midi: 'audio/midi',
      Mpeg: 'audio/mpeg',
      Wav: 'audio/ogg',
      Webm: 'video/webm',
      Ogg: 'video/ogg',
      Text: 'text/plain'
    },
    OrigenDocumentoEscritorio: 1,
    OrigenDocumentoScanner: 2,
    OrigenDocumentoStrings: [
      { key: 1, text: 'ARCHIVO SISTEMA' },
      { key: 2, text: 'DIGITALIZAR' },
    ],
    TipoDocumentoStrings: [
      { key: 1, text: 'FÍSICO' },
      { key: 2, text: 'DIGITAL' },
    ],
    TipoIdentificacion: {
      Nit: 2
    },
    TiposFirmaComunicadoInterno: {
      Electronica: true,
      Digital: false,
      Manuscrita: false
    }
  },
  def: {
    deleteButton: (callback: () => void) => {
      return {
        key: 'Eliminar',
        name: 'Eliminar',
        iconProps: { iconName: 'Delete' },
        onClick: callback
      }
    },
    editButton: (callback: () => void) => {
      return {
        key: 'Editar',
        name: 'Editar',
        iconProps: { iconName: 'Edit' },
        onClick: callback
      }
    },
    btn: {
      exportButton: (callback: () => void) => {
        return {
          key: 'Exportar',
          name: 'Exportar',
          iconProps: { iconName: 'ExcelLogo16' },
          title: 'Exportar los resultados actuales',
          onClick: callback
        }
      },
      exportExcel: (service: () => Promise<Blob>, filename: string) => {
        return {
          key: 'Exportar',
          name: 'Exportar',
          iconProps: { iconName: 'ExcelLogo16' },
          title: 'Exportar los resultados actuales',
          onClick: () => {
            $_.utils.downloadService(service, filename);
          }
        }
      },
      newButton: (href: string) => {
        return {
          key: 'Nuevo',
          name: 'Nuevo',
          iconProps: { iconName: 'Add' },
          title: 'Crear nuevo elemento',
          href: href.indexOf('#') === 0 ? href : '#' + href
        }
      },
      bulkLoad: (callback: () => void) => {
        return {
          key: 'Carga masiva',
          name: 'Carga masiva',
          iconProps: { iconName: 'BulkUpload' },
          title: 'Carga masiva',
          onClick: callback
        }
      },
      downloadTemplate: (href: string) => {
        return {
          key: 'Descargar plantilla',
          name: 'Descargar plantilla',
          iconProps: { iconName: 'Download' },
          title: 'Descarga la plantilla de carga masiva',
          onClick: () => {
            window.open(href, '_blank');
          }
        }
      },
      deleteItem: (callback: () => Promise<void>): IContextualMenuItem => {
        return {
          key: 'Eliminar',
          name: 'Eliminar',
          iconProps: { iconName: 'Delete' },
          title: 'Elimina el elemento seleccionado',
          onClick: () => {
            showConfirmation('Eliminar elemento', '¿Está seguro que desea eliminar el elemento seleccionado?', callback);
          }
        }
      },
      editHref: (href: string) => {
        return {
          key: 'Editar',
          name: 'Editar',
          iconProps: { iconName: 'Edit' },
          title: 'Editar',
          href: href.indexOf('#') === 0 ? href : '#' + href
        }
      },
    }
  },
  utils: {
    downloadBlob: (blob: Blob, filename: string, mimeType?: string) => {
      const a = document.createElement('a');
      const url = window.URL.createObjectURL(blob);
      a.href = url;
      a.download = filename;
      a.click();
      window.URL.revokeObjectURL(url);
    },
    downloadExcel: (blob: Blob, filename: string) => {
      $_.utils.downloadBlob(blob, filename, $_.const.MimeTypes.Exce2007AndAbove);
    },
    downloadPdf: (blob: Blob, filename: string) => {
      $_.utils.downloadBlob(blob, filename, $_.const.MimeTypes.Pdf);
    },
    downloadService: async (service: () => Promise<Blob>, filename: string, mimeType?: string) => {
      try {
        const blob: Blob = await service();
        $_.utils.downloadBlob(blob, filename, mimeType);
      } catch (error) {
        showError((error as any).ExceptionMessage);
      }
    },
    downloadServiceExcel: async (service: Promise<Blob>, filename: string) => {
      try {
        const blob: Blob = await service;
        $_.utils.downloadBlob(blob, filename, $_.const.MimeTypes.Exce2007AndAbove);
      } catch (error) {
        showError((error as any).ExceptionMessage);
      }
    }
  },
  isNull: (obj: any): boolean => {
    return obj === undefined || obj == null;
  },
  isNullOrEmpty: (obj: any): boolean => {
    return obj === undefined || obj == null || typeof (obj) !== 'string' || obj.trim() === '';
  },
  extensions: {}
}

export interface IComponent {

}

export interface IEntityBase {
  CreadoPor?: string,
  MaquinaCreacion?: string,
  FechaCreacion?: Date;
  FechaCreacionString?: string;
  FechaCreacionString2?: string;
  ModificadoPor?: string,
  MaquinaModificacion?: string,
  FechaModificacion?: Date;
  FechaModificacionString?: string;
  FechaModificacionString2?: string;
}

export interface IListPage<T> {
  rows: T[],
  selectedRow: T;
  RecordsTotal: number;
  RecordsFiltered: number;
  hideDialogConfirmation: boolean;
  isLoading?: boolean;
  commandBar?: IContextualMenuItem[];
  LastItem: number;
}

export interface IModelPage<T> {
  model: T;
  hideDialogConfirmation: boolean;
  formIsSaving?: boolean;
  errors?: { [ key: string ]: string };
}

export interface IService<T> {
  getByIdAsync(id: number): Promise<T>;
  getAllAsync(): Promise<T[]>;
  saveAsync(obj: T): Promise<number>;
  deleteAsync(id: number): Promise<void>;
  paginateAsync(request: DataTableRequest | { [ key: string ]: any }): Promise<DataTablesResponse>;
}

export function truncate(value: number = 0) {
  const with2Decimals = value.toString().match(/^-?\d+(?:\.\d{0,2})?/)[ 0 ]
  return with2Decimals;
}

export enum PermisoSeccion {
  Usuario = 1,
  ResponsableSeccion = 2,
  Asociacion = 3
}

export const _routes_ = {











  BANDEJA_ENTRADA: '/bandeja-entrada',

  // Perfiles
  PERFILES: '/perfiles',
  CREAR_PERFIL: '/crear-perfil',
  EDITAR_PERFIL: '/editar-perfil/:id',

  // Usuarios
  USUARIOS: '/usuarios',
  CREAR_USUARIO: '/crear-usuario',
  EDITAR_USUARIO: '/editar-usuario/:id',

  // Usuarios asociados por sección
  USUARIOS_ASOCIADOS_SECCION: '/archivox/administracion/usuarios-asociados-seccion',
  CREAR_ASOCIACION_USUARIO_SECCION: '/archivox/administracion/crear-usuario-asociado-seccion',

  // Consecutivos
  CONSECUTIVOS: '/administracion/gestor-documental/consecutivos',
  CREAR_CONSECUTIVO: '/administracion/gestor-documental/crear-consecutivo',
  EDITAR_CONSECUTIVO: '/administracion/gestor-documental/editar-consecutivo/:id',

  // Metadatos
  CATEGORIAS_METADATOS: '/metadatos',
  CREAR_CATEGORIA_METADATO: '/crear-metadato',
  EDITAR_CATEGORIA_METADATO: '/editar-metadato/:id',

  // Fondos
  FONDOS: '/administracion/fondos',
  CREAR_FONDO: '/administracion/crear-fondo',
  EDITAR_FONDO: '/administracion/editar-fondo/:id',

  // Secciones
  SUCURSALES: '/administracion/sucursales',
  CREAR_SUCURSAL: '/administracion/gestor-documental/crear-sucursal',
  EDITAR_SUCURSAL: '/administracion/gestor-documental/editar-sucursal/:id',

  // Secciones
  SECCIONES: '/administracion/secciones',
  CREAR_SECCION: '/administracion/gestor-documental/crear-seccion',
  EDITAR_SECCION: '/administracion/gestor-documental/editar-seccion/:id',

  // Series
  SERIES: '/administracion/gestor-documental/series',
  CREAR_SERIE: '/administracion/gestor-documental/crear-serie',
  EDITAR_SERIE: '/administracion/gestor-documental/editar-serie/:id',

  // Subseries
  SUBSERIES: '/administracion/gestor-documental/subseries',
  CREAR_SUBSERIE: '/administracion/gestor-documental/crear-subserie',
  EDITAR_SUBSERIE: '/administracion/gestor-documental/editar-subserie/:id',

  // Tipos documentales
  TIPOS_DOCUMENTALES: '/administracion/tipos-documentales',
  CREAR_TIPO_DOCUMENTAL: '/administracion/crear-tipo-documental',
  EDITAR_TIPO_DOCUMENTAL: '/administracion/editar-tipo-documental/:id',

  // Carpetas
  CARPETAS: '/administracion/gestor-documental/carpetas',
  CREAR_CARPETA: '/administracion/gestor-documental/crear-carpeta',
  EDITAR_CARPETA: '/administracion/gestor-documental/editar-carpeta/:id',

  // Tablas de retención documental
  TABLAS_RETENCION_DOCUMENTAL: '/administracion/gestor-documental/trds',
  CREAR_TABLA_RETENCION_DOCUMENTAL_PRINCIPAL: '/administracion/gestor-documental/crear-trd',
  EDITAR_TABLA_RETENCION_DOCUMENTAL_PRINCIPAL: '/administracion/gestor-documental/editar-trd/:id',
  VER_TABLA_RETENCION_DOCUMENTAL_HISTORICA: '/administracion/gestor-documental/hitorico-trd/:id/:version',




























  REPORTES_POWER_BI: '/administracion/reportes-power-bi',

  // Bandeja de entrada

  REDIRECT: '/redirect',
  GESTIONAR_BANDEJA: '/gestionar-bandeja',

  // Tipo de parámetro
  TIPOS_PARAMETROS: '/administracion/tipos-parametros',
  CREAR_TIPO_PARAMETRO: '/administracion/crear-tipo-parametro',
  EDITAR_TIPO_PARAMETRO: '/administracion/editar-tipo-parametro/:id',

  // Parámetro
  PARAMETROS: '/administracion/tipos-parametros',
  CREAR_PARAMETRO: '/administracion/crear-tipo-parametro/:idTipoParametro',
  EDITAR_PARAMETRO: '/administracion/editar-tipo-parametro/:idTipoParametro/:id',














  // Librerias
  LIBRERIAS: '/administracion/suscripcion/librerias',

  // Extensiones
  EXTENSION_RUNTIME: '/extensions/:extensionName/:viewId',









  // Zonas
  ZONAS: '/administracion/correspondencia/zonas',
  CREAR_ZONA: '/administracion/correspondencia/crear-zona',
  EDITAR_ZONA: '/administracion/correspondencia/editar-zona/:id',

  // Medios de envío
  MEDIOS_ENVIO: '/administracion/correspondencia/medios-envio',
  CREAR_MEDIO_ENVIO: '/administracion/correspondencia/crear-medio-envio',
  EDITAR_MEDIO_ENVIO: '/administracion/correspondencia/editar-medio-envio/:id',

  // Motivos de devolución
  MOTIVOS_DEVOLUCION: '/administracion/correspondencia/motivos-devolucion',
  CREAR_MOTIVO_DEVOLUCION: '/administracion/correspondencia/crear-motivo-devolucion',
  EDITAR_MOTIVO_DEVOLUCION: '/administracion/correspondencia/editar-motivo-devolucion/:id',

  // Creación de expedientes
  EXPEDIENTES_GESTION: '/expedientes/gestion',
  EXPEDIENTES_CENTRAL: '/expedientes/central',
  EXPEDIENTES_HISTORICO: '/expedientes/historico',
  CREAR_EXPEDIENTE: '/crear-expediente',

  // Ver expediente
  VER_EXPEDIENTE_GESTION: '/expediente/gestion/ver-expediente/:id',
  VER_EXPEDIENTE_CENTRAL: '/expediente/central/ver-expediente/:id',
  VER_EXPEDIENTE_HISTORICO: '/expediente/historico/ver-expediente/:id',

  // transferencias
  TRANSFERENCIAS_RESPONSABLE: '/archivox/transferencias/pendientes-gestion',

  // Búsqueda de expedientes
  BUSQUEDA_EXPEDIENTE_GESTION: '/expedientes-gestion',
  BUSQUEDA_EXPEDIENTE_CENTRAL: '/expedientes-central',
  BUSQUEDA_EXPEDIENTE_HISTORICO: '/expedientes-historico',

  // Aprobación transferencias
  APROBACION_TRANSFERENCIA_PRIMARIA: '/archivox/transferencias/aprobacion-primaria',
  APROBACION_TRANSFERENCIA_SECUNDARIA: '/archivox/transferencias/aprobacion-secundaria',

  // Contactos
  CONTACTOS: '/contactos',
  CREAR_CONTACTO: '/crear-contacto',
  EDITAR_CONTACTO: '/editar-contacto/:id',

  // Alertas
  ALERTAS: '/administracion/correspondencia/alertas',
  CREAR_ALERTA: '/administracion/correspondencia/crear-alerta',
  EDITAR_ALERTA: '/administracion/correspondencia/editar-alerta/:id',

  // Tramites
  TRAMITES: '/administracion/correspondencia/tramites',
  CREAR_TRAMITE: '/administracion/correspondencia/crear-tramite',
  EDITAR_TRAMITE: '/administracion/correspondencia/editar-tramite/:id',

  // Flujos documentales
  FLUJOS: '/administracion/shared/flujos-documentales',
  CREAR_FLUJO: '/administracion/shared/nuevo-flujo',
  CREAR_FLUJO_DOCUMENTAL: '/administracion/shared/nuevo-flujo-documental',
  EDITAR_FLUJO_DOCUMENTAL: '/administracion/shared/editar-flujo-documental/:id',

  // Festivos
  FESTIVOS: '/administracion/correspondencia/dias-festivos',
  CREAR_FESTIVO: '/administracion/correspondencia/crear-festivo',
  EDITAR_FESTIVO: '/administracion/correspondencia/editar-festivo/:id',

  // Clasificación PQRS
  CLASIFICACIONES_PQRS: '/clasificaciones-pqrs',
  CLASIFICACION_PQRS: '/clasificacion-pqrs',

  // Creación rádicado de entrada
  CREAR_RADICADO_ENTRADA_FISICO: '/crear-radicado-entrada/fisico',
  CREAR_RADICADO_ENTRADA_DIGITAL: '/crear-radicado-entrada/digital',

  // Creación rádicado de entrada
  DIGITALIZAR_RADICADO_ENTRADA_DIGITAL: '/gestion/radicado-entrada/digitalizacion/:idRadicadoEntrada/:idTarea',

  // Radicado de entrada - Radicado
  RADICADO_ENTRADA_FISICO_RADICADO: '/gestion/radicado-entrada/radicado/fisico/:idRadicadoEntrada/:idTarea',
  RADICADO_ENTRADA_DIGITAL_RADICADO: '/gestion/radicado-entrada/radicado/digital/:idRadicadoEntrada/:idTarea',
  RADICADO_ENTRADA_FISICO_ANONIMO_RADICADO: '/gestion/radicado-entrada/radicado/anonimo/fisico/:idRadicadoEntrada/:idTarea',
  RADICADO_ENTRADA_DIGITAL_ANONIMO_RADICADO: '/gestion/radicado-entrada/radicado/anonimo/digital/:idRadicadoEntrada/:idTarea',
  // PQR - Radicado
  PQR_FISICO_RADICADO: '/gestion/pqr/radicado/fisico/:idRadicadoEntrada/:idTarea',
  PQR_DIGITAL_RADICADO: '/gestion/pqr/radicado/digital/:idRadicadoEntrada/:idTarea',
  PQR_FISICO_ANONIMO_RADICADO: '/gestion/pqr/radicado/anonimo/fisico/:idRadicadoEntrada/:idTarea',
  PQR_DIGITAL_ANONIMO_RADICADO: '/gestion/pqr/radicado/anonimo/digital/:idRadicadoEntrada/:idTarea',

  // Radicado de entrada personalizado
  EXTENSION_RADICADO_ENTRADA_FISICO: '/tramitex/extensions/radicado-entrada/radicado/fisico/:extensionId/:idRadicadoEntrada/:idTipoTarea/:idTarea/:idSolicitud',
  EXTENSION_RADICADO_ENTRADA_DIGITAL: '/tramitex/extensions/radicado-entrada/radicado/digital/:extensionId/:idRadicadoEntrada/:idTipoTarea/:idTarea/:idSolicitud',
  EXTENSION_RADICADO_ENTRADA_FISICO_ANONIMO: '/tramitex/extensions/radicado-entrada/radicado/anonimo/fisico/:extensionId/:idRadicadoEntrada/:idTipoTarea/:idTarea/:idSolicitud',
  EXTENSION_RADICADO_ENTRADA_DIGITAL_ANONIMO: '/tramitex/extensions/radicado-entrada/radicado/anonimo/digital/:extensionId/:idRadicadoEntrada/:idTipoTarea/:idTarea/:idSolicitud',
  EXTENSION_PQR_FISICO: '/tramitex/extensions/pqr/radicado/fisico/:extensionId/:idRadicadoEntrada/:idTipoTarea/:idTarea/:idSolicitud',
  EXTENSION_PQR_DIGITAL: '/tramitex/extensions/pqr/radicado/digital/:extensionId/:idRadicadoEntrada/:idTipoTarea/:idTarea/:idSolicitud',
  EXTENSION_PQR_FISICO_ANONIMO: '/tramitex/extensions/pqr/radicado/anonimo/fisico/:extensionId/:idRadicadoEntrada/:idTipoTarea/:idTarea/:idSolicitud',
  EXTENSION_PQR_DIGITAL_ANONIMO: '/tramitex/extensions/pqr/radicado/anonimo/digital/:extensionId/:idRadicadoEntrada/:idTipoTarea/:idTarea/:idSolicitud',

  // Radicado de entrada - En trámite
  RADICADO_ENTRADA_FISICO_EN_TRAMITE: '/gestion/radicado-entrada/en-tramite/fisico/:idRadicadoEntrada/:idTarea',
  RADICADO_ENTRADA_DIGITAL_EN_TRAMITE: '/gestion/radicado-entrada/en-tramite/digital/:idRadicadoEntrada/:idTarea',
  RADICADO_ENTRADA_FISICO_ANONIMO_EN_TRAMITE: '/gestion/radicado-entrada/en-tramite/anonimo/fisico/:idRadicadoEntrada/:idTarea',
  RADICADO_ENTRADA_DIGITAL_ANONIMO_EN_TRAMITE: '/gestion/radicado-entrada/en-tramite/anonimo/digital/:idRadicadoEntrada/:idTarea',

  // Edición radicado de entrada
  VISTA_VENTANILLA_FISICO: '/gestion/radicado-entrada/devuelto/fisico/:idRadicadoEntrada/:idTarea',
  VISTA_VENTANILLA_DIGITAL: '/gestion/radicado-entrada/devuelto/digital/:idRadicadoEntrada/:idTarea',

  // Edición radicado de entrada de solo lectura
  COPIA_RADICADO_ENTRADA_FISICO: '/gestion/radicado-entrada/fisico/:idRadicadoEntrada',
  COPIA_RADICADO_ENTRADA_DIGITAL: '/gestion/radicado-entrada/digital/:idRadicadoEntrada',

  // Incluir en expediente - flujo documental
  INCLUIR_EXPEDIENTE_FLUJO_DOCUMENTAL_FISICO: '/gestion/flujo-documental/radicado-entrada/incluir-expediente/fisico/:idRadicadoEntrada/:idTarea',
  INCLUIR_EXPEDIENTE_FLUJO_DOCUMENTAL_DIGITAL: '/gestion/flujo-documental/radicado-entrada/incluir-expediente/digital/:idRadicadoEntrada/:idTarea',

  // Aprobación flujo documental
  APROBACION_FLUJO_DOCUMENTAL_FISICO: '/gestion/flujo-documental/radicado-entrada/fisico/:idRadicadoSalida/:idPasoFlujoDocumental/:idTarea/:esAprobacionFinal/:permitirDevolver',
  APROBACION_FLUJO_DOCUMENTAL_DIGITAL: '/gestion/flujo-documental/radicado-entrada/digital/:idRadicadoSalida/:idPasoFlujoDocumental/:idTarea/:esAprobacionFinal/:permitirDevolver',

  // Cración radicado de salida
  CREAR_RADICADO_SALIDA_FISICO: '/crear-radicado-salida/fisico/:idExpediente/:idRadicadoEntrada?',
  CREAR_RADICADO_SALIDA_DIGITAL: '/crear-radicado-salida/digital/:idExpediente/:idRadicadoEntrada?',

  // Edición radicado de salida
  EDITAR_RADICADO_SALIDA_FISICO: '/editar-radicado-salida/fisico/:idRadicadoSalida/:idTarea',
  EDITAR_RADICADO_SALIDA_DIGITAL: '/editar-radicado-salida/digital/:idRadicadoSalida/:idTarea',

  // Respuesta solicitud de visto bueno Radicado de Salida
  RESPONDER_SOLICITUD_VISTO_BUENO_DIGITAL: '/responder-solicitud-visto-bueno-digital/:idRadicadoSalida/:idSolicitudVistoBueno/:idUsuarioSolicitudVistoBueno/:idTarea',
  RESPONDER_SOLICITUD_VISTO_BUENO_FISICO: '/responder-solicitud-visto-bueno-fisico/:idRadicadoSalida/:idSolicitudVistoBueno/:idUsuarioSolicitudVistoBueno/:idTarea',

  APROBAR_RADICADO_SALIDA_DIGITAL: '/aprobar-rsd/:idRadicadoSalida/:idAprobacion/:idTarea',
  APROBAR_RADICADO_SALIDA_FISICO: '/aprobar-rsf/:idRadicadoSalida/:idAprobacion/:idTarea',

  // Radicado de salida PQR
  RADICADO_SALIDA_PQR_DIGITAL: '/crear-radicado-salida/pqr/digital/:idExpediente/:idRadicadoEntrada?',
  RADICADO_SALIDA_PQR_FISICO: '/crear-radicado-salida/pqr/fisico/:idExpediente/:idRadicadoEntrada?',

  // Edición radicado de salida PQR
  EDITAR_RADICADO_SALIDA_PQR_DIGITAL: '/editar-radicado-salida/pqr/digital/:idRadicadoSalida/:idTarea',
  EDITAR_RADICADO_SALIDA_PQR_FISICO: '/editar-radicado-salida/pqr/fisico/:idRadicadoSalida/:idTarea',

  // Responder solicitud de información radicado de entrada
  RESPONDER_SOLICITUD_CONCEPTO_FISICO: '/gestion/radicado-salida/solicitud-concepto/fisico/:idRadicadoSalida/:idSolicitudConcepto/:idUsuarioSolicitudConcepto/:idTarea',
  RESPONDER_SOLICITUD_CONCEPTO_DIGITAL: '/gestion/radicado-salida/solicitud-concepto/digital/:idRadicadoSalida/:idSolicitudConcepto/:idUsuarioSolicitudConcepto/:idTarea',
  RESPONDER_SOLICITUD_CONCEPTO_FISICO_ANONIMO: '/gestion/radicado-salida/solicitud-concepto/fisico/anonimo/:idRadicadoSalida/:idSolicitudConcepto/:idUsuarioSolicitudConcepto/:idTarea',
  RESPONDER_SOLICITUD_CONCEPTO_DIGITAL_ANONIMO: '/gestion/radicado-salida/solicitud-concepto/digital/anonimo/:idRadicadoSalida/:idSolicitudConcepto/:idUsuarioSolicitudConcepto/:idTarea',







  // Respuesta solicitud de visto bueno Radicado de Salida PQR
  RESPONDER_SOLICITUD_VISTO_BUENO_PQR_DIGITAL: '/responder-solicitud-visto-bueno/pqr/digital/:idRadicadoSalida/:idSolicitudVistoBueno/:idTarea',
  RESPONDER_SOLICITUD_VISTO_BUENO_PQR_FISICO: '/responder-solicitud-visto-bueno/pqr/fisico/:idRadicadoSalida/:idSolicitudVistoBueno/:idTarea',

  // Aprobación Radicado de Salida PQR
  APROBAR_RADICADO_SALIDA_PQR_DIGITAL: '/aprobar-radicado-salida/pqr/digital/:idRadicadoSalida/:idAprobacion/:idTarea',
  APROBAR_RADICADO_SALIDA_PQR_FISICO: '/aprobar-radicado-salida/pqr/fisico/:idRadicadoSalida/:idAprobacion/:idTarea',

  // Impresión de documentos
  IMPRESION_DOCUMENTOS: '/impresion-documentos',

  // Envío de documentos
  DOCUMENTOS_PENDIENTES_RECIBIR: '/envio-documentos/documentos-pendientes-recibir',

  ASIGNACION_ENVIOS: '/envio-documentos/asignacion-envios',
  GENERAR_PLANILLA: '/envio-documentos/generar-planilla',
  COMPROBANTE_ENTREGA: '/comprobantes-entrega',

  RECEPCION_FISICA: '/correspondencia/gestion/recepcion-fisica',

  CAPTURA_RE: '/captura-re',

  CAPTURA_RS: '/captura-rs',

  // Comunicado interno
  CREAR_COMUNICADO_INTERNO: '/crear-comunicado-interno/:idExpediente/:idVersionTablaRetencionDocumental',
  EDITAR_COMUNICADO_INTERNO: '/editar-comunicado-interno/:id/:idTarea',
  APROBAR_COMUNICADO_INTERNO: '/aprobar-comunicado-interno/:id/:idTarea',
  COMUNICADO_INTERNO_RECHAZADO: '/comunicado-interno-rechazado/:id/:idTarea',
  VER_COMUNICADO_INTERNO_PUBLICADO: '/ver-comunicado-interno/:id/:idTarea',
  RESPONDER_COMUNICADO_INTERNO: '/responder-comunicado-interno/:id',
  RESPONDER_SOLICITUD_VISTO_BUENO_COMUNICADO_INTERNO: '/gestion/comunicado-interno/responder-solicitud-visto-bueno/:id/:idSolicitudVistoBueno/:idsuarioSolicitudVistoBueno/:idTarea',
  MODO_LECTURA_COMUNICADO_INTERNO: '/consultar-comunicado-interno/:id',

  BUSQUEDA_AVANZADA_CORRESPONDENCIA: '/correspondencia/busqueda-avanzada',


  PARAMETRIZACION_CORRESPONDENCIA: '/correspondencia/administracion-general',
  APP_CONFIG: '/profile/my/settings',



  /**
   * Redirecciona a una ruta especifica
   * @param path Nueva ruta
   */
  redirect: (path: string): void => {
    if (path.indexOf('#') !== 0) {
      path = '#' + path;
    }
    (window.location as any).href = path;
  },

  back: (defaultUrl: string): void => {
    _routes_.redirect(defaultUrl);
  }

}

let _fetchCount: number = 0;
let _background = document.createElement('div');
_background.style.display = 'none';
_background.style.position = 'absolute';
_background.style.left = '0px';
_background.style.top = '0px';
_background.style.background = 'rgba(255, 255, 255, 0.5803921568627451)';
_background.style.zIndex = '999999999';
(document.body as any).append(_background);

let _loader = document.createElement('div');
_loader.style.display = 'none';
_loader.style.width = '96px';
_loader.style.height = '96px';
_loader.style.position = 'absolute';
_loader.style.zIndex = '8888888888';
_loader.innerHTML = `<img style="width: 100%; height: 100%;" id="ioip-loader-icon" src="https://memexpoxtacdn.blob.core.windows.net/memex-poxta-core/loader.gif" />`;
(document.body as any).append(_loader);

export function addFetch() {
  _fetchCount++;
  _background.style.display = 'block';
  _background.style.width = window.document.body.offsetWidth + 'px';
  _background.style.height = window.document.body.scrollHeight + 'px';
  _loader.style.display = 'block';
  (document.body as any).style.overflow = 'hidden';
  _loader.style.left = ((window.document.body.offsetWidth / 2) - 48) + 'px';
  _loader.style.top = ((window.document.body.offsetHeight / 2) - 48) + 'px';
}

export function removeFetch(allow?: boolean) {
  if (_fetchCount > 0) {
    _fetchCount--;
  }
  if (_fetchCount == 0) {
    _background.style.display = 'none';
    _loader.style.display = 'none';
    (document.body as any).style.overflow = 'auto';
  }
}

export function getFileExtension(fileName: string): string {
  const splitString = fileName.split('.');
  const extension = splitString.length >= 2 ? splitString[ splitString.length - 1 ] : 'desconocido';
  return extension;
}
export function getFileName(fileName: string): string {
  let splitString = fileName.split('.');
  if (splitString.length === 1) {
    return splitString[ 0 ];
  } else {
    splitString.splice(splitString.length - 1, 1);
    return splitString.join('.');
  }
}

export const DATETIME_ERROR_STYLE: CSSProperties = {
  color: 'rgb(168, 0, 0)',
  fontSize: '14px'
}

export interface ISTYLES {
  BANDEJA_ENTRADA: {
    ASUNTO: CSSProperties;
    DESCRIPCION: CSSProperties;
  };
  APP: CSSProperties;
  SMALL_ERROR: CSSProperties;
  CARD: CSSProperties;
  CARD_LIGTH: CSSProperties;
  CONFIGURATION_TITLE: CSSProperties;
  CONFIGURATION_CARD: CSSProperties;
}

export const STYLES: ISTYLES = {
  APP: {
    backgroundColor: '#E5EBF2',
    height: 'calc(100% - 77px)'
  },
  BANDEJA_ENTRADA: {
    ASUNTO: {
      margin: '0px',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    },
    DESCRIPCION: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      textAlign: 'right'
    }
  },
  SMALL_ERROR: {
    fontSize: '12px',
    fontWeight: 400,
    color: '#a80000'
  },
  CARD: {
    border: 'solid 1px silver',
    marginBottom: '10px',
    boxShadow: '1px 3px 4px 0px #b19f9f',
    padding: '8px',
    maxWidth: '100%',
    marginLeft: '0px'
  },
  CARD_LIGTH: {
    border: 'solid 1px silver',
    marginBottom: '10px',
    boxShadow: 'rgb(226, 226, 226) 1px 1px 1px 0px',
    padding: '8px',
    maxWidth: '100%',
    marginLeft: '0px'
  },
  CONFIGURATION_TITLE: {
    marginTop: '30px',
    marginBottom: '0px'
  },
  CONFIGURATION_CARD: {
    border: 'solid 1px #efefef',
    marginBottom: '10px',
    padding: '8px',
    maxWidth: '100%',
    marginLeft: '0px',
    paddingBottom: '15px',
    marginTop: '15px'
  }
}

const baseProductionCdnUrl = 'https://static2.sharepointonline.com/files/fabric/office-ui-fabric-react-assets/';

export const TestImages = {
  choiceGroupBarUnselected: baseProductionCdnUrl + 'choicegroup-bar-unselected.png',
  choiceGroupBarSelected: baseProductionCdnUrl + 'choicegroup-bar-selected.png',
  choiceGroupPieUnselected: baseProductionCdnUrl + 'choicegroup-pie-unselected.png',
  choiceGroupPieSelected: baseProductionCdnUrl + 'choicegroup-pie-selected.png',
  documentPreview: baseProductionCdnUrl + 'document-preview.png',
  documentPreviewTwo: baseProductionCdnUrl + 'document-preview2.png',
  documentPreviewThree: baseProductionCdnUrl + 'document-preview3.png',
  iconOne: baseProductionCdnUrl + 'icon-one.png',
  iconPpt: baseProductionCdnUrl + 'icon-ppt.png',
  personaFemale: baseProductionCdnUrl + 'persona-female.png',
  personaMale: baseProductionCdnUrl + 'persona-male.png'
};

let autoincrement = 0;
export const VanillaToasts = {
  create: function (options: any) {
    var toast = document.createElement('div') as any; toast.id = ++autoincrement; toast.id = 'toast-' + toast.id; toast.className = 'vanillatoasts-toast'; if (options.title) { var h4 = document.createElement('h4'); h4.className = 'vanillatoasts-title'; h4.innerHTML = options.title; toast.appendChild(h4); }
    if (options.text) { var p = document.createElement('p'); p.className = 'vanillatoasts-text'; p.innerHTML = options.text; toast.appendChild(p); }
    if (options.icon) { var img = document.createElement('img'); img.src = options.icon; img.className = 'vanillatoasts-icon'; toast.appendChild(img); }
    if (typeof options.callback === 'function') { toast.addEventListener('click', options.callback); }
    toast.hide = function () { toast.className += ' vanillatoasts-fadeOut'; toast.addEventListener('animationend', removeToast, false); }; if (options.timeout) { setTimeout(toast.hide, options.timeout); }
    if (options.type) { toast.className += ' vanillatoasts-' + options.type; }
    toast.addEventListener('click', toast.hide); function removeToast() { document.getElementById('vanillatoasts-container').removeChild(toast); }
    document.getElementById('vanillatoasts-container').appendChild(toast); return toast;
  }
};

export function onFormatDate(date: Date): string {

  if (typeof (date) === 'string') {
    date = new Date(date);
  }

  let day = String(date.getDate());
  day = day.length === 1 ? '0' + day : day;

  let month = String(date.getMonth() + 1);
  month = month.length === 1 ? '0' + month : month;

  if (typeof (date) === 'object') {
    return day + '/' + month + '/' + (date.getFullYear());
  } else {
    return date;
  }
};

export interface ICustomItemDetailList {
  thumbnail: string;
  key: string;
  name: string;
  description: string;
  color: string;
  shape: string;
  location: string;
  width: number;
  height: number;
}

/**
* Representa el resultado de la validación de un control
* @param {number|function} type Nombre del tipo de validación
*/
export class ValidationResult {

  validationType: string = '';
  hasError: boolean = false;
  errorMessage: string = '';
  value: any = null;
  expectedValue: any = null;

  constructor(validationType?: string) {
    this.validationType = validationType;
  }

  static createError(errorMessage: string) {
    const result = new ValidationResult();
    result.hasError = true;
    result.errorMessage = errorMessage;
    return result;
  }

  static createSuccess() {
    const result = new ValidationResult();
    return result;
  }

}

export const validator = {

  required: function validator(value) {
    value = value || true;
    return function validator(formValue) {

      var response = new ValidationResult('validator.required');

      // Obtener el valor a comparar
      var expectedValue = null;
      if (typeof (value) === 'function') {
        expectedValue = value();
      } else if (typeof (value) === 'boolean') {
        expectedValue = value;
      } else {
        throw new Error('El valor establecido para la regla de validación "validator.maxLength" no es valido.');
      }

      response.expectedValue = expectedValue;
      response.value = formValue;

      // Obtener la longitud del valor
      if (expectedValue === true && (formValue == null || formValue.toString().length === 0)) {
        response.hasError = true;
        response.errorMessage = 'Campo requerido';
      }
      return response;
    }
  },

  maxLength: function validator(value: number | Function, customMessageError?: string | Function) {
    return function validator(formValue) {

      var response = new ValidationResult('validator.maxLength');

      // Obtener el valor a comparar
      var expectedValue = null;
      if (typeof (value) === 'function') {
        expectedValue = value();
      } else if (typeof (value) === 'number') {
        expectedValue = value;
      } else {
        throw new Error('El valor establecido para la regla de validación "validator.maxLength" no es valido.');
      }

      // Verificar que el valor esperado sea mayor a cero
      if (expectedValue > 0) {

        // Obtener la longitud del valor

        var lenght = 0;
        if (formValue == null) {
          formValue = 0;
        } else if (typeof (formValue) === 'string') {
          lenght = formValue.toString().length
        } else if (typeof (formValue) === 'number') {
          lenght = formValue.toString().length
        }

        response.expectedValue = expectedValue;
        response.value = lenght;

        // Realizar validación
        if (lenght > expectedValue) {
          response.hasError = true;
          response.errorMessage = customMessageError ?
            typeof customMessageError === 'function' ? customMessageError() :
              customMessageError : `Se permite máximo ${expectedValue} caracteres.`;
        }
      }
      return response;
    }
  },

  minLength: function minLengthValidator(value: number | Function, customMessageError?: string | Function) {
    return function minLengthValidator(formValue) {

      var response = new ValidationResult('validator.minLength');

      // Obtener el valor a comparar
      var expectedValue = null;
      if (typeof (value) === 'function') {
        expectedValue = value();
      } else if (typeof (value) === 'number') {
        expectedValue = value;
      } else {
        throw new Error('El valor establecido para la regla de validación "validator.minLength" no es valido.');
      }

      if (expectedValue > 0) {

        // Obtener la longitud del valor
        var lenght = 0;
        if (formValue == null) {
          formValue = 0;
        } else if (typeof (formValue) === 'string') {
          lenght = formValue.toString().length;
        } else if (typeof (formValue) === 'number') {
          lenght = formValue.toString().length;
        } else if (typeof (formValue) === 'object' && formValue instanceof Array) {
          lenght = formValue.length;
        }

        response.expectedValue = expectedValue;
        response.value = lenght;

        // Realizar validación
        if (lenght < expectedValue) {
          response.hasError = true;
          response.errorMessage = customMessageError ?
            typeof customMessageError === 'function' ? customMessageError() :
              customMessageError : `Se requiere ingresar como mínimo ${expectedValue} caracteres.`;
        }
      }
      return response;
    }
  },

  maxValue: function maxValueValidator(value: number | Function, customMessageError?: string | Function) {
    return function maxValueValidator(formValue) {

      var response = new ValidationResult('validator.maxValue');

      // Obtener el valor a comparar
      var expectedValue = null;
      if (typeof (value) === 'function') {
        expectedValue = value();
      } else if (typeof (value) === 'number') {
        expectedValue = value;
      } else {
        throw new Error('El valor establecido para la regla de validación "validator.maxLength" no es valido.');
      }

      response.expectedValue = expectedValue;
      response.value = formValue;
      if (formValue > expectedValue) {
        response.hasError = true;
        response.errorMessage = customMessageError ?
          typeof customMessageError === 'function' ? customMessageError() :
            customMessageError : `El valor máximo permitido es ${expectedValue} caracteres.`;
      }

      return response;
    }
  },

  minValue: function minValueValidator(value: number | Function, customMessageError?: string | Function) {
    return function minValueValidator(formValue) {

      var response = new ValidationResult('validator.minValue');

      var expectedValue = null;
      if (typeof (value) === 'function') {
        expectedValue = value();
      } else if (typeof (value) === 'number') {
        expectedValue = value;
      } else {
        throw new Error('El valor establecido para la regla de validación "validator.minValue" no es valido.');
      }

      response.expectedValue = expectedValue;
      response.value = formValue;
      if (formValue < expectedValue) {
        response.hasError = true;
        response.errorMessage = customMessageError ?
          typeof customMessageError === 'function' ? customMessageError() :
            customMessageError : `El valor minimo permitido es ${expectedValue} caracteres.`;
      }

      return response;
    }
  },

  invalid: function validator(value: any, errorMessage: string) {
    return function validator(formValue: any) {

      var response = new ValidationResult('validator.invalid');

      var expectedValue = null;
      if (typeof (value) === 'function') {
        expectedValue = value();
      } else if (typeof (value) === 'number') {
        expectedValue = value;
      } else {
        throw new Error('El valor establecido para la regla de validación "validator.invalid" no es valido.');
      }

      response.expectedValue = expectedValue;
      response.value = formValue;
      if (formValue == expectedValue) {
        response.hasError = true;
        response.errorMessage = errorMessage;
      }

      return response;
    }
  },

  custom: function validator(callback: (value: any) => ValidationResult) {
    return function validator(formValue) {
      return callback(formValue);
    }
  },

  maxDate: function maxDateValidator(value: Date | Function, customMessageError?: string | Function) {
    return function maxDateValidator(formValue) {

      var response = new ValidationResult('validator.maxDate');

      // Obtener el valor a comparar
      var expectedValue = null;
      if (typeof (value) === 'function') {
        expectedValue = value();
      } else if (typeof (value) === 'object') {
        expectedValue = value;
      } else {
        throw new Error('El valor establecido para la regla de validación "validator.maxDate" no es valido.');
      }

      response.expectedValue = expectedValue;
      response.value = formValue;
      if (formValue > expectedValue) {
        response.hasError = true;
        response.errorMessage = customMessageError ?
          typeof customMessageError === 'function' ? customMessageError() :
            customMessageError : `la fecha máxima permitida es ${expectedValue}.`;
      }

      return response;
    }
  },

  minDate: function minDateValidator(value: Date | Function, customMessageError?: string | Function) {
    return function minDateValidator(formValue) {

      var response = new ValidationResult('validator.minDate');

      // Obtener el valor a comparar
      var expectedValue = null;
      if (typeof (value) === 'function') {
        expectedValue = value();
      } else if (typeof (value) === 'object') {
        expectedValue = value;
      } else {
        throw new Error('El valor establecido para la regla de validación "validator.minDate" no es valido.');
      }

      response.expectedValue = expectedValue;
      response.value = formValue;
      if (formValue < expectedValue) {
        response.hasError = true;
        response.errorMessage = customMessageError ?
          typeof customMessageError === 'function' ? customMessageError() :
            customMessageError : `la fecha mínima permitida es ${expectedValue}.`;
      }

      return response;
    }
  },

  email: function validator(errorMessage?: string) {
    return function validator(formValue: string) {
      const response = new ValidationResult('validator.email');
      if (formValue.trim().length > 0) {
        response.value = formValue;
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (re.test(formValue) === false) {
          response.hasError = true;
          response.errorMessage = 'Formato de correo no valido' || errorMessage;
        }
      }
      return response;
    }
  },

  domainUser: function domainUserValidator(errorMessage?: string) {
    return function domainUserValidator(formValue: string) {
      const response = new ValidationResult('validator.domainUser');
      if (formValue.trim().length > 0) {
        response.value = formValue;
        const re = /^[A-Za-z0-9\\\._-]{7,}$/;
        if (re.test(formValue) === false) {
          response.hasError = true;
          response.errorMessage = 'Formato de usuario de dominio no valido' || errorMessage;
        }
      }
      return response;
    }
  },

  identity: function identityValidator(errorMessage?: string) {
    return function identityValidator(formValue: string) {
      const response = new ValidationResult('validator.identity');
      if (!$_.isNullOrEmpty(formValue)) {
        response.value = formValue;
        const re = /^[0-9]+$/;
        if (re.test(formValue) === false) {
          response.hasError = true;
          response.errorMessage = 'Formato no válido, no debe contener caracteres' || errorMessage;
        }
      }
      return response;
    }
  },

  onlyText: function validator(errorMessage?: string) {
    return function validator(formValue: string) {
      const response = new ValidationResult('validator.onlyText');
      if (formValue.trim().length > 0) {
        response.value = formValue;
        const re = /^[a-zA-Z ]+$/;
        if (re.test(formValue) === false) {
          response.hasError = true;
          response.errorMessage = 'Texto no valido' || errorMessage;
        }
      }
      return response;
    }
  },



};

export function validateProperty(propertyValue: string | number, validations: any[]): ValidationResult {

  let result: ValidationResult = new ValidationResult();

  if (validations == null) {
    return result;
  }

  for (var i = 0; i < validations.length; i++) {
    var validation = validations[ i ];
    if (typeof (validation) != 'function') {
      throw new Error('El validador debe ser una función');
    }
    else {
      var tmp = validation(propertyValue);
      if (tmp.hasError === true) {
        result = tmp;
        break;
      }
    }
  }

  return result;
}

export function validateObject(model: { [ key: string ]: any }, validations: { [ key: string ]: any }, output: ((errors: { [ key: string ]: string }, isValid: boolean) => void)): boolean {

  let isValid: boolean = true;
  let key: string;
  let errors: { [ key: string ]: string } = {};
  for (key in model) {
    let value = model[ key ];
    let _validations = validations[ key ];
    if (_validations != null && _validations.length > 0) {
      let validationResult: ValidationResult = validateProperty(value, _validations);
      if (validationResult.hasError) {
        isValid = false;
        errors[ key ] = validationResult.errorMessage;
      } else {
        errors[ key ] = '';
      }
    }
  }
  // Actualizar errores
  output(errors, isValid);
  return isValid;
}

export interface IAppServices {

  ProcesoX: {
    ProjectSvc: ProjectService;
  },

  ArchivoxClient: ArchivoxClient;
  TipoContactoSvc: TipoContactoService;
  TIPO_IDENTIFICACION_SERVICE: TipoIdentificacionService;
}

export function defaultIAppServices(): IAppServices {
  return {
    ProcesoX: {
      ProjectSvc: new ProjectService()
    },
    ArchivoxClient: new ArchivoxClient(),
    TipoContactoSvc: new TipoContactoService(),
    TIPO_IDENTIFICACION_SERVICE: new TipoIdentificacionService(),
  };
}

export interface IExtensionAplicacion {
  IdAplicacion: number;
  IdExtensionAplicacion: number;
  ClassName: string;
  Aplicacion: string;
}

export interface IOpcionSeleccionable {
  Nombre: string;
  IdOpcionListaDesplegableMetadato: number;
  IdMetadato: number;
  Activo: boolean;
}

export function defaultIOpcionSeleccionable(): IOpcionSeleccionable {
  return {
    Activo: false,
    IdMetadato: 0,
    IdOpcionListaDesplegableMetadato: 0,
    Nombre: ''
  };
}

export interface IParametro extends IEntityBase {
  IdTipoParametro: number;
  IdParametro: number;
  Nombre: string;
  Descripcion: string;
  Valor: string;
  Activo: boolean;
}

export interface ITipoColumnaMetadato {
  IdTipoColumnaMetadato: number;
  Nombre: string;
  Descripcion: string;
  Activo: boolean;
}

export interface IValorMetadato {
  IdValorMetadato: number;
  IdExpediente: number;
  IdDocumentoExpediente: number;
  IdMetadato: number;
  Valor: any;
  IdOpcionListaDesplegableMetadato: number;
  Nombre?: string;
  Codigo: string;
  CategoriaMetadato?: string;
}

export enum TipoColumnaMetadato {
  Texto = 1,
  Nota = 2,
  Fecha = 3,
  Seleccion = 4,
  SiNo = 5,
  Numero = 6,
  Moneda = 7,
  Usuario = 8,
  ExpresionRegular = 9,
  Pais = 10,
  Departamento = 11,
  Ciudad = 12,
  TipoIdentificacion = 13,
  Custom = 14,
  Metadato = 15,
  Titulo = 16,
  Parrafo = 17,
  Contactos = 18,
  ContactosPersonas = 19,
  ContactosEntidades = 20,
  CustomMultiSeleccion = 21
}

export interface IDocumento {
  Nombre: string;
  NombreArchivo?: string;
  ServerRelativeUrl?: string;
  Length: number;
  UniqueId?: string
  ODataId?: string
  Extension: string;
  Archivo?: File;
  Archivo64?: string;
  Tipo?: string;
  IdDocumentoExpediente?: number;
  IdAnexoDocumentoExpediente?: number;
  IdDocumentoRadicadoEntrada?: number;
  Cargado?: boolean;
  IdDocumentoRadicadoSalida?: number;
  IdRadicadoEntrada?: number;
  IdRadicadoSalida?: number;
  IdComunicadoInterno?: number;
  IdDocumentoComunicadoInterno?: number;
  // Propiedades adicionales
  Data?: any;
  PreventRemove?: boolean;
  IsDropZoneFile?: boolean;
}

export function defaultIDocumento(): IDocumento {
  return {
    Nombre: '',
    NombreArchivo: '',
    ServerRelativeUrl: '',
    Length: 0,
    UniqueId: '',
    ODataId: '',
    Extension: '',
    Archivo: undefined,
    Archivo64: '',
    Tipo: '',
    IdDocumentoExpediente: 0,
    IdAnexoDocumentoExpediente: 0,
    IdDocumentoRadicadoEntrada: 0,
    IdDocumentoRadicadoSalida: 0,
    IdDocumentoComunicadoInterno: 0,
    IdRadicadoEntrada: 0,
    IdRadicadoSalida: 0,
    IdComunicadoInterno: 0,
    Data: undefined,
    PreventRemove: false,
    IsDropZoneFile: false
  }
}

export enum Rol {
  AdministradorArchivox = 1,
  AdministradorTramitex = 2,
  CrearExpediente = 3,
  DistribucionInterna = 4,
  DigitalizacionRE = 5,
  BusquedaExpedienteGestion = 6,
  BusquedaExpedienteCentral = 7,
  BusquedaExpedienteHistorico = 8,
  TransferenciaPrimaria = 9,
  TransferenciaSecundaria = 10,
  DescargarIndiceElectronico = 11,
  EmpaquetarExpediente = 12,
  Ventanilla = 13,

  ImpresionDocumentos = 14,

  /// <summary>
  /// 
  /// </summary>
  RecoleccionDocumentos = 15,

  PoxtaEnvioDocumentos = 16,

  DigitalizacionRS = 17,

  ResponderRadicadoEntrada = 18,

  EmpaquetarExpedienteCentral = 19,
  EmpaquetarExpedienteHistorico = 20,
  DescargarIndiceElectronicoCentral = 21,
  DescargarIndiceElectronicoHistorico = 22,
  AprobarRadicado = 23,
  CrearComunicadoInterno = 24,
  AprobarComunicadoInterno = 25,
  DescargarTipoDocumental = 26,
  EmpaquetarMasivamente = 27,
  ImprimirDocumental = 28,
  VerificarIntegridad = 29,

  /// <summary>
  /// Permite la crear, modificar y eliminar contactos
  /// </summary>
  AdministrarContactos = 30,

  EditarDocumentosAnexosRadicadoEntrada = 31,
  ReclasificarPQRD = 32,
  AnulacionRadicadoSalida = 33,
  Correspondencia_ReimpresionSticker = 34,
  GestionarBandejas = 35,
  BusquedaCorrespondenciaPorUsuarioResponsable = 36,
  ReportesPowerBI = 37,
  AdministradorFlujos = 38,
  VisualizarCorrespondenciaBusquedaAvanzada = 39,
  ExportarHistoricoExpediente = 40,
  ExportarDirectorioExpedientes = 41,
  AdministradorSuscripcion = 42,
}

export interface IClasificacionPQRS {
  IdClasificacionPQRS: number;
  IdClasificacionPQRSPadre: number;
  Nombre: string;
  Descripcion: string;
  IdAlcanceTema: number;
  IdUsuarioResponsable: number;
  RegistroWeb: boolean;
  RegistroVentanilla: boolean;
  RegistroMesaAyuda: boolean;
  Activo: boolean;
  IdPrioridadTema: number;
  PalabrasClave: string;
  HabilitarOtraClasificacionPQR: boolean;
  SeccionUsuarioResponsable: string;
}

export interface ITramiteProps {
  OnRenderRadicadoEntradaMetadata?: string;
  ProcesoxFormVersionId?: string;
  ProcesoxProjectId?: string;
  ShowButtonInWeb?: boolean;
}

export const defaultITramiteProps = (): ITramiteProps => {
  return {
    ShowButtonInWeb: false
  };
}

export interface IContactType {
  ContactTypeId: number;
  Name: boolean;
  IsAnonymous: boolean;
}

export interface ITramite {
  Activo: boolean;
  Descripcion: string;
  Funcion: string;
  Componente: string;
  IdTipoAsignacionTramite: number;
  IdTipoEjecucionGestionTramite: number;
  IdTramite: number;
  Nombre: string;
  Props?: ITramiteProps;
  RegistroWeb: boolean;
  TiposContacto: IContactType[]
}

export function defaultITramite(): ITramite {
  return {
    Activo: false,
    Componente: '',
    Descripcion: '',
    Funcion: '',
    IdTipoAsignacionTramite: 1,
    IdTipoEjecucionGestionTramite: 0,
    IdTramite: 0,
    Nombre: '',
    RegistroWeb: true,
    TiposContacto: []
  };
}

export enum TipoAsignacionTramiteEnum {
  UsuarioPredeterminado = 1,
  AsignarUnoAUno = 2,
  AsignarAlQueMenosTenga = 3,
  SeleccionarUsuarioCerrado = 4,
  SeleccionarUsuarioAbierto = 5,
  Clasificacion = 7
}

export enum TipoEjecucionGestionTramiteEnum {
  CaseManagement = 1,
  FlujoDocumental = 2,
  Proceso = 3
}

export interface IContacto {
  IdContacto: number;
  IdTipoContacto: number;
  TipoContacto: string;
  IdTipoIdentificacion: number;
  TipoIdentificacion: string;
  Identificacion: string;
  Nombres: string; // Almacena la razón social de las empresas
  Apellidos: string; // Almacena las siglas de las empresas
  Direccion: string;
  Barrio: string;
  Telefono: string;
  Celular: string;
  Extension: string;
  Email: string;
  IdCiudad: number;
  Ciudad: string;
  IdDepartamento: number;
  Departamento: string;
  IdPais: number;
  Pais: string;
  Activo: boolean;
  CodigoPostal: string;
  Cargo: string;
  IdGenero: number;
  IdGrupoEtnico: number;
  IdAntencionPreferencial: number;
  IdDiscapacidad: number;
  NombreRepresentante: string;
  EmailRepresentante: string;
  CargoRepresentante: string;
  TelefonoRepresentante: string;
  IdTipoPersona: number;
  TipoPersona: string;
  FechaNacimiento: Date;
  FechaNacimientoString: string;
  IdNivelEducativo: number;
  IdProfesion: number;
  IdTipoEntidad: number;
  ActuaComoApoderado: boolean;
  IdTipoIdentificacionApoderado: number;
  TipoIdentificacionApoderado: string;
  IdentificacionApoderado: string;
  NombresApoderado: string;
  ApellidosApoderado: string;
  DireccionApoderado: string;
  TelefonoApoderado: string;
  EmailApoderado: string;
  AutorizaNotificacionEmail: boolean;
  AutorizaNotificacionFisica: boolean;
  AutorizaLlamadaFijo: boolean;
  AutorizaLlamadaCelular: boolean;
  AutorizaTratamientoDatos: boolean;
}

export function defaultIContacto(): IContacto {
  return {
    IdContacto: 0,
    IdTipoContacto: 0,
    TipoContacto: '',
    IdTipoIdentificacion: 0,
    TipoIdentificacion: '',
    Identificacion: '',
    Nombres: '',
    Apellidos: '',
    Direccion: '',
    Barrio: '',
    Telefono: '',
    Celular: '',
    Extension: '',
    Email: '',
    IdCiudad: 0,
    Ciudad: '',
    IdDepartamento: 0,
    Departamento: '',
    IdPais: 0,
    Pais: '',
    Activo: false,
    CodigoPostal: '',
    Cargo: '',
    IdGenero: 0,
    IdGrupoEtnico: 0,
    IdAntencionPreferencial: 0,
    IdDiscapacidad: 0,
    NombreRepresentante: '',
    EmailRepresentante: '',
    CargoRepresentante: '',
    TelefonoRepresentante: '',
    IdTipoPersona: 0,
    TipoPersona: '',
    FechaNacimiento: null,
    FechaNacimientoString: '',
    IdNivelEducativo: 0,
    IdProfesion: 0,
    IdTipoEntidad: 0,
    ActuaComoApoderado: false,
    IdTipoIdentificacionApoderado: 0,
    TipoIdentificacionApoderado: '',
    IdentificacionApoderado: '',
    NombresApoderado: '',
    ApellidosApoderado: '',
    DireccionApoderado: '',
    TelefonoApoderado: '',
    EmailApoderado: '',
    AutorizaNotificacionEmail: true,
    AutorizaNotificacionFisica: false,
    AutorizaLlamadaFijo: false,
    AutorizaLlamadaCelular: false,
    AutorizaTratamientoDatos: false
  };
}

export interface ICopiaRadicado extends IEntityBase {
  IdCopiaRadicadoEntrada: number;
  IdCopiaRadicadoSalida: number;
  IdRadicado: number;
  IdSeccion: number;
  Seccion: string;
  IdUsuario: number;
  Usuario: string;
}

export interface IDestinatarioRespuestaPQRS {
  IdDestinatarioRespuestaPQRS: number;
  Nombre: string;
}

export interface IDocumentoUsuarioSolicitudConcepto {
  IdDocumentoUsuarioSolicitudConcepto?: number;
  IdUsuarioSolicitudConcepto?: number;
  IdDocumentoUsuarioSolicitudVistoBueno?: number;
  IdUsuarioSolicitudVistoBueno?: number;
  ServerRelativeUrl?: string;
  UniqueId?: string;
  ODataId?: string;
  Length?: number;
  NombreArchivo?: string;
  Nombre?: string;
  Extension?: string;
  Hash?: string;
  Archivo64?: string;
  Archivo?: File;
  DocumentoRadicadoEntrada?: boolean;
}

export enum EstadoRadicado {
  Borrador = 1,
  CapturaRE = 2,
  DistribucionPendiente = 3,
  Radicado = 4,
  EnTramite = 5, // Cuando se incluye en un expediente, el radicado queda en tramite
  PendienteRecibir = 6,
  DistribucionRealizada = 7,
  DevueltoRecepcionFisica = 8, // Cuando se devuelve a ventanilla y este debe asignar de nuevo
  Respondido = 9,
  PendienteAclaracion = 11,
  PendienteInformacion = 12,
  PendienteAmpliacion = 13,

  //SIPAR
  Archivado = 161
}

export enum EstadoRadicadoSalida {

  Default = 0,

  /// <summary>
  /// El radicado se encuentra en trámite
  /// </summary>
  EnTramite = 1,

  /// <summary>
  /// El radicado de entrada se encuentra en proceso de visto bueno.
  /// </summary>
  SolicitudVistoBueno = 2,

  /// <summary>
  /// El radicado de salida tiene una solicitud de aprobación pendiente
  /// </summary>
  EnAprobacion = 3,

  /// <summary>
  /// El radicado de entrada ya fue aprobado. Solo si es fisico queda pendiente por imprimir
  /// </summary>
  Aprobado = 4,

  /// <summary>
  /// Documento ya fue impreso y queda pendiente para sea recolectado por el enrutador
  /// </summary>
  Impreso = 5,

  /// <summary>
  /// Documento ya fue recolectado y queda pendiente para que sea recibido
  /// </summary>
  Recolectado = 6,

  /// <summary>
  /// El documento es recibido por ventanilla en el formulario "Envio de documentos / Pendiente por recibir"
  /// </summary>
  Recibido = 7,

  /// <summary>
  /// El documento ya finalizo la fase de digitalización en CAPTURA RE
  /// </summary>
  Digitalizado = 8,

  /// <summary>
  /// Al radicado de salida ya se le finalizao el paso de asignación envio
  /// </summary>
  AsignadoParaEnvio = 9,

  /// <summary>
  /// Ya se genero planilla
  /// </summary>
  PlanillaGenerada = 10,

  /// <summary>
  /// El radicado fue entregado
  /// </summary>
  Entregado = 11,

  /// <summary>
  /// El radicado fue devuelto
  /// </summary>
  Devuelto = 12,

  /// <summary>
  /// El radicado fue anulado
  /// </summary>
  Anulado = 13
}

export interface IGenerarPlanillaUpdateModel {
  NumeroGuia: string;
  NumeroOrden: string;
  FechaEnvio: Date;
  Direccion: string;
}

export function defaultIGenerarPlanillaUpdateModel(): IGenerarPlanillaUpdateModel {
  return {
    NumeroGuia: '',
    NumeroOrden: '',
    FechaEnvio: new Date(),
    Direccion: '',
  }
}

export interface IRadicadoEntrada {
  Anexos: IDocumento[];
  CustomMetadata: IDictionary<any>;
  Anonima: boolean;
  Apellidos: string;
  Asunto: string;
  AutorizaRespuestaCorreoElectronicoOSitioWeb: boolean;
  CantidadFolios: number;
  Ciudad: string,
  ClasificacionPQRS: string;
  ComprobanteEntrega?: IDocumento;
  ComprobanteEntregado?: boolean;
  CopiasRadicadoEntrada: ICopiaRadicado[];
  Departamento: string,
  Digital: boolean;
  Direccion: string;
  Distribucion: string;
  Email: string;
  Extension: string;
  IdAlerta: number;
  IdCiudad: number,
  IdClasificacionPQRS: number;
  IdContacto: number;
  IdDepartamento: number,
  Identificacion: string;
  IdEstadoActual: EstadoRadicado;
  IdExpediente: number;
  IdOficioRemisorioSharePoint: number;
  IdPais: number;
  IdRadicadoEntrada: number;
  IdRadicadoEntradaVinculado: number;
  IdRadicadoSalidaVinculado: number;
  IdReferencia: number;
  IdSeccion: number;
  IdTarea: number;
  IdTipoContacto: number;
  IdTipoDocumental: number;
  IdTipoEjecucionGestionTramite: number;
  IdTipoIdentificacion: number;
  IdTramite: number;
  IdUsuarioResponsable: number;
  MedioRecepcionEmpresaMensajeria: string;
  MedioRecepcionEsCorreoCertificado: boolean;
  MedioRecepcionNumeroGuiaRecepcion: string;
  MetadatosAsociados: IMetadatoAsociado[];
  Nombres: string;
  NumeroAnexos: number;
  NumeroExpediente: string;
  NumeroPreRadicado: string;
  NumeroRadicado: string;
  NumeroRadicadoSalida: string;
  OficioRemisorio: IDocumento;
  Pais: string;
  PqrWeb: boolean;
  PrefiereRespuestaFisica: boolean;
  ProcesoxData: { [ key: string ]: any };
  RadicadoEsDigital: boolean;
  RecepcionFisica: boolean;
  Referencia: string;
  Seccion: string;
  ServerRelativeUrl: string;
  Telefono: string;
  TiempoMaximoRespuesta: Date;
  TiempoMaximoRespuestaString: string;
  TipoContacto: string;
  TipoIdentificacion: string;
  Tramite: string;
  UrlOficioRemisorioSharePoint: string;
  UsuarioResponsable: string;
  ValoresMetadatos: IValorMetadato[];
  RepresentaRiesgo: boolean;
}

export interface IMetadatoAsociado {
  IdMetadatoSubserie: number;
  IdMetadato: number;
  IdTipoColumnaMetadato: TipoColumnaMetadato;
  IdCategoriaMetadato: number;
  IdMetadatoFlujo: number;
  IdMetadatoPasoFlujoDocumental: number;
  CategoriaMetadato: string;
  Nombre: string;
  Descripcion: string;
  Asociado: boolean;
  Lectura: boolean;
  Escritura: boolean;
  Requerido: boolean;
  Busqueda: boolean;
  Orden: number;
  TamanoCompleto: boolean;
  Opciones?: IComboBoxOption[];
  LongitudMinima?: number;
  LongitudMaxima?: number;
  ValorPorDefecto?: string;
  ValorMinimo?: number;
  ValorMaximo?: number;
  FechaMaxima?: Date;
  FechaMinima?: Date;
  ExpresionRegular?: string;
  Valor?: any;
  Reglas: string;
  ReglaRequerido: string;
  ReglaVisible: string;
  ReglaListaDesplegable?: string;
  Mostrar: boolean;
  RegistroVentanilla: boolean;
  RegistroMesaAyuda: boolean;
  RegistroWeb: boolean;
  NombreCategoriaMetadato: string;
  Aplicacion: string;
  ClassName: string;
  KeyField: string;
  TextField: string;
  Codigo: string;
}


export interface IMetadato extends IEntityBase {
  ReglaVisible?: string;
  ReglaRequerido?: string;
  IdMetadato: number;
  IdCategoriaMetadato: number;
  CategoriaMetadato: string;
  IdTipoColumnaMetadato: number;
  IdListaDesplegableMetadato: number;
  TipoColumnaMetadato: string;
  Nombre: string;
  Descripcion: string;
  Activo: boolean;
  LongitudMinima: number;
  LongitudMaxima: number;
  ValorPorDefecto: string;
  ValorMinimo: number;
  ValorMaximo: number;
  FechaMaxima: Date;
  FechaMinima: Date;
  ExpresionRegular: string;
  ItemsSeleccion: number;
  NombreOpcion: string;
  NombreOpcionAnterior: string;
  Opciones: IOpcionSeleccionable[];
  OpcionesSeleccionadas: IOpcionSeleccionable[];
  Requerido?: boolean;
  Asociado?: boolean;
  TamanoCompleto?: boolean;
  Orden?: number;
  Externo?: boolean;
  IdAplicacion?: number;
  IdExtensionAplicacion?: number;
  ClassName?: string;
  Mostrar?: boolean;
}


export interface ICategoriaMetadato extends IEntityBase {
  IdCategoriaMetadato: number;
  Nombre: string;
  Descripcion: string;
  Activo: boolean;
  Metadatos: IMetadato[];
}

export function defaultIMetadatoAsociado(): IMetadatoAsociado {
  return {
    IdMetadatoSubserie: 0,
    IdTipoColumnaMetadato: TipoColumnaMetadato.Texto,
    IdCategoriaMetadato: 0,
    CategoriaMetadato: '',
    IdMetadatoFlujo: 0,
    IdMetadatoPasoFlujoDocumental: 0,
    IdMetadato: 0,
    Asociado: false,
    Nombre: '',
    Descripcion: '',
    Requerido: false,
    Busqueda: false,
    Orden: 0,
    TamanoCompleto: false,
    Escritura: false,
    Lectura: false,
    Reglas: '',
    ReglaRequerido: '',
    ReglaVisible: '',
    ReglaListaDesplegable: '',
    Mostrar: false,
    RegistroMesaAyuda: false,
    RegistroVentanilla: false,
    RegistroWeb: false,
    NombreCategoriaMetadato: '',
    Aplicacion: '',
    ClassName: '',
    KeyField: '',
    TextField: '',
    Codigo: ''
  }
}

export function defaultIRadicadoEntrada(): IRadicadoEntrada {
  return {
    Anexos: [],
    Anonima: false,
    Apellidos: '',
    Asunto: '',
    AutorizaRespuestaCorreoElectronicoOSitioWeb: false,
    CantidadFolios: 0,
    Ciudad: '',
    ClasificacionPQRS: '',
    ComprobanteEntrega: defaultIDocumento(),
    ComprobanteEntregado: false,
    CopiasRadicadoEntrada: [],
    Departamento: '',
    Digital: true,
    CustomMetadata: {},
    Direccion: '',
    Distribucion: '',
    Email: '',
    Extension: '',
    IdAlerta: 0,
    IdCiudad: 0,
    IdClasificacionPQRS: 0,
    IdContacto: 0,
    IdDepartamento: 0,
    Identificacion: '',
    IdEstadoActual: 0 as any,
    IdExpediente: 0,
    IdOficioRemisorioSharePoint: 0,
    IdPais: 0,
    IdRadicadoEntrada: 0,
    IdRadicadoEntradaVinculado: 0,
    IdRadicadoSalidaVinculado: 0,
    IdReferencia: 0,
    IdSeccion: 0,
    IdTarea: 0,
    IdTipoContacto: 0,
    IdTipoDocumental: 0,
    IdTipoEjecucionGestionTramite: 0,
    IdTipoIdentificacion: 0,
    IdTramite: 0,
    IdUsuarioResponsable: 0,
    MedioRecepcionEmpresaMensajeria: '',
    MedioRecepcionEsCorreoCertificado: false,
    MedioRecepcionNumeroGuiaRecepcion: '',
    MetadatosAsociados: [],
    Nombres: '',
    NumeroAnexos: 0,
    NumeroExpediente: '',
    NumeroPreRadicado: '',
    NumeroRadicado: '',
    NumeroRadicadoSalida: '',
    OficioRemisorio: defaultIDocumento(),
    Pais: '',
    PqrWeb: false,
    PrefiereRespuestaFisica: false,
    ProcesoxData: {},
    RadicadoEsDigital: false,
    RecepcionFisica: false,
    Referencia: '',
    Seccion: '',
    ServerRelativeUrl: '',
    Telefono: '',
    TiempoMaximoRespuesta: undefined,
    TiempoMaximoRespuestaString: '',
    TipoContacto: '',
    TipoIdentificacion: '',
    Tramite: '',
    UrlOficioRemisorioSharePoint: '',
    UsuarioResponsable: '',
    ValoresMetadatos: [],
    RepresentaRiesgo: false
  };
}

export interface IRadicadoSalidaResponse {
  IdRadicadoSalida: number;
  IdTarea: number;
  CarpetaRadicadoSalida: string;
  NombreArchivoRadicadoSalida: string;
}

export interface IRadicadoSalida {
  IdRadicadoSalida: number;
  IdRadicadoEntrada?: number;
  NumeroRadicadoEntrada: string;
  RadicadoEntradaDigital: boolean;
  IdDocumentoExpediente: number;
  Anonima?: boolean;
  IdTramite: number;
  IdEstadoActual: EstadoRadicadoSalida;
  EstadoActual: string;
  Digital: boolean;
  NumeroRadicado: string;
  IdExpediente: number;
  IdContacto: number;
  IdTipoContacto: number;
  TipoContacto: string;
  IdTipoIdentificacion: number;
  TipoIdentificacion: string;
  Identificacion: string;
  Nombres: string;
  Apellidos: string;
  Direccion: string;
  Telefono: string;
  Extension: string;
  Celular: string;
  Email: string;
  Pais: string;
  IdDepartamento: number;
  Departamento: string;
  IdCiudad: number;
  Ciudad: string;
  IdPais: number;
  Asunto: string;
  CantidadFolios: number;
  IdTipoDocumental: number;
  TipoDocumental: string;
  IdUsuarioResponsable: number;
  UsuarioResponsable: string;
  IdSeccionAprobador: number;
  SeccionAprobador: string;
  IdUsuarioAprobador: number;
  UsuarioAprobador: string;
  PlantillaDocumento: IDocumento;
  CopiasExternas: IContacto[];
  NotificacionesInternas: ICopiaRadicado[];
  OtrosDestinatarios: IContacto[];
  AnexosRadicadoSalida?: IDocumento[],
  IdTipoRespuestaPQRS: TipoRespuestaPQRS;
  TipoRespuestaPQRS: string;
  DestinatarioRespuestaPQRS: string;
  DesistimientoTacito: boolean;
  Serie: string;
  Subserie: string;
  Seccion: string;
  UsuarioResponsableExpediente: string;
  Pqr: boolean;
  ComprobanteEntrega: IDocumento,
  RadicadoEntregado: boolean;
  FechaRecibeDocumento: Date;
  SharePointLibrary: string;
  NumeroGuia: string;
  NumeroPlanilla: string;
  TipoEnvio: string;
  ZonaEnvio: string;
  FechaEnvio: Date;
  IdAsignacionEnvioRadicadoSalida: number;
  IdMotivoDevolucion: number;
  DownloadUrl: string;
  IdContactoDestinatarioRespuesta: number;
  CelularDestinatarioRespuesta: string;
  TelefonoDestinatarioRespuesta: string;
  ExtensionDestinatarioRespuesta: string;
  EmailDestinatarioRespuesta: string;
  IdTipoIdentificacionDestinatarioRespuesta: number;
  IdentificacionDestinatarioRespuesta: string;
  NombresDestinatarioRespuesta: string;
  ApellidosDestinatarioRespuesta: string;
  DireccionDestinatarioRespuesta: string;
  IdCiudadDestinatarioRespuesta: number;
  IdDepartamentoDestinatarioRespuesta: number;
  IdPaisDestinatarioRespuesta: number;
  IdTipoContactoDestinatarioRespuesta: number;
  IdDocumentoRadicadoSalida?: number;
  Impreso?: boolean;
  NumeroExpediente: string;
}

export function defaultIRadicadoSalida(): IRadicadoSalida {
  return {
    IdRadicadoSalida: 0,
    IdRadicadoEntrada: 0,
    NumeroRadicadoEntrada: '',
    RadicadoEntradaDigital: false,
    IdDocumentoExpediente: 0,
    Anonima: false,
    IdTramite: 0,
    IdEstadoActual: EstadoRadicadoSalida.Default,
    EstadoActual: '',
    Digital: false,
    NumeroRadicado: '',
    IdExpediente: 0,
    IdContacto: 0,
    IdTipoContacto: 0,
    TipoContacto: '',
    IdTipoIdentificacion: 0,
    TipoIdentificacion: '',
    Identificacion: '',
    Nombres: '',
    Apellidos: '',
    Direccion: '',
    Telefono: '',
    Extension: '',
    Celular: '',
    Email: '',
    IdCiudad: 0,
    Ciudad: '',
    IdDepartamento: 0,
    Departamento: '',
    IdPais: 0,
    Pais: '',
    Asunto: '',
    CantidadFolios: 1,
    IdTipoDocumental: 0,
    TipoDocumental: '',
    IdUsuarioResponsable: 0,
    UsuarioResponsable: '',
    IdSeccionAprobador: 0,
    SeccionAprobador: '',
    IdUsuarioAprobador: 0,
    UsuarioAprobador: '',
    PlantillaDocumento: defaultIDocumento(),
    CopiasExternas: [],
    NotificacionesInternas: [],
    OtrosDestinatarios: [],
    AnexosRadicadoSalida: [],
    IdTipoRespuestaPQRS: TipoRespuestaPQRS.Default,
    TipoRespuestaPQRS: '',
    DestinatarioRespuestaPQRS: '',
    DesistimientoTacito: false,
    Serie: '',
    Subserie: '',
    Seccion: '',
    UsuarioResponsableExpediente: '',
    Pqr: false,
    ComprobanteEntrega: defaultIDocumento(),
    RadicadoEntregado: true,
    FechaRecibeDocumento: undefined,
    SharePointLibrary: '',
    NumeroGuia: '',
    NumeroPlanilla: '',
    TipoEnvio: '',
    ZonaEnvio: '',
    FechaEnvio: null,
    IdAsignacionEnvioRadicadoSalida: 0,
    IdMotivoDevolucion: 0,
    DownloadUrl: '',
    IdContactoDestinatarioRespuesta: 0,
    CelularDestinatarioRespuesta: '',
    TelefonoDestinatarioRespuesta: '',
    ExtensionDestinatarioRespuesta: '',
    EmailDestinatarioRespuesta: '',
    IdTipoIdentificacionDestinatarioRespuesta: 0,
    IdentificacionDestinatarioRespuesta: '',
    NombresDestinatarioRespuesta: '',
    ApellidosDestinatarioRespuesta: '',
    DireccionDestinatarioRespuesta: '',
    IdCiudadDestinatarioRespuesta: 0,
    IdDepartamentoDestinatarioRespuesta: 0,
    IdPaisDestinatarioRespuesta: 0,
    IdTipoContactoDestinatarioRespuesta: TipoContacto.Empresa,
    IdDocumentoRadicadoSalida: 0,
    Impreso: false,
    NumeroExpediente: ''
  };
}

export interface ITipoContacto {
  IdTipoContacto: number;
  Nombre: string;
  Activo: boolean;
}

export interface ITipoIdentificacion {
  IdTipoIdentificacion: number;
  Nombre: string;
  Activo?: boolean;
  IdTipoPersona: number;
}

export interface ITipoPersona {
  IdTipoPersona: number;
  Nombre: string;
  Activo?: boolean;
}

export interface INivelEducativo {
  IdNivelEducativo: number;
  Nombre: string;
  Activo: boolean;
}

export interface IProfesion {
  IdProfesion: number;
  Nombre: string;
  Activo: boolean;
}

export enum TipoRespuestaPQRS {
  Default = 0,
  Definitiva = 1,
  Parcial = 2,
  Aclaracion = 3,
  Ampliacion = 4,
  Informacion = 5
}

export interface ITipoRespuestaPQRS {
  IdTipoRespuestaPQRS: number;
  Nombre: string;
  Orden: number;
}

export interface ITipoSolicitante {
  IdTipoSolicitante: number;
  Nombre: string;
  Activo: boolean;
  IdTipoPersona: number;
}

export enum TipoContacto {
  Default = 0,
  Ciudadano = 1,
  Empresa = 2,
  Congresista = 3,
  Anonimo = 4
}

/**
 * Enumeración que contiene los tramites predeterminados del sistema
 */
export enum TipoTramite {
  /**
   * El tramite de correspondencia implica que en el radicado de entrada se debe seleccionar la sección y usuario responsable
   */
  Correspondencia = 1,
  /**
   * El tramite de PQRS implica que en el radicado de entrada se debe seleccionar la clasificación
   */
  PQRS = 2,
  /**
  * Los tramites de aporte implican que se debe indicar el numero del radicado de entrada al que se hace el aporte.
  */
  AporteInformacion = 70,
  AporteAmpliacion = 71,
  AporteAclaracion = 72
}

export class ArchivoxClient extends BaseService {

  constructor() {
    super();
    this.controller = '';
  }

  private get baseUrl(): string {
    return `tramitex-web-client/api/${(window as any).domain}`;
  }

  public async getAllDepartmentsAsync(): Promise<IDepartment[]> {
    return this.aadGet<IDepartment[]>(`${this.baseUrl}/departamentos`);
  }

  public async getAllCountriesAsync(): Promise<ICountry[]> {
    return this.aadGet<ICountry[]>(`${this.baseUrl}/paises`);
  }

  public async getAllCitiesAsync(): Promise<ICity[]> {
    return this.aadGet<ICity[]>(`${this.baseUrl}/ciudades`);
  }

}

export class TipoContactoService extends BaseService {

  constructor() {
    super();
    this.controller = 'v1/TipoContacto';
  }

  public async getAllAsync(): Promise<ITipoContacto[]> {
    return this.aadGet<ITipoContacto[]>(this.controller);
  }

}

export class TipoIdentificacionService extends BaseService {

  constructor() {
    super();
    this.controller = 'v1/TipoIdentificacion';
  }

  public async getAllAsync(): Promise<ITipoIdentificacion[]> {
    return this.aadGet<ITipoIdentificacion[]>(this.controller);
  }

}

export async function ensureFetch<T>(request: Promise<T>, callback: (result: T) => void): Promise<void> {
  try {
    let result = await request;
    if (typeof callback === 'function') {
      callback(result);
    }
  } catch (ex) {
    debugger
    showError((ex as any).ExceptionMessage || (ex as any).exceptionMessage);
  }
}

export class ProjectService extends BaseService {

  constructor() {
    super();
  }

  public downloadFieldDataSourceAsync(projectId: string, formVersionId: string, fieldId: string, filters: IDictionary<any>): Promise<IDataSourceResponse> {
    return this._getFormfieldDataSourceAsync(`${Sede.Shared.ProcesoxUrl}/apps/${projectId}/form-versions/${formVersionId}/fields/${fieldId}/datasource`, filters);
  }

  public downloadParametricEntityItems(projectId: string, entityId: string): Promise<IDictionary<any>[]> {
    return this.aadGet(`${Sede.Shared.ProcesoxUrl}/apps/${projectId}/entities/${entityId}/items`);
  }

  public getFormAsync(formVersionId: string): Promise<IJSFormV1> {
    const apiUrl = `${Sede.Shared.ProcesoxUrl}/forms/${formVersionId}`;
    return this.aadGet<IJSFormV1>(apiUrl);
  }

  public async getPageAsync(formVersionId: Guid): Promise<IJSPage> {
    const apiUrl = `${Sede.Shared.ProcesoxUrl}/pages/${formVersionId}`;
    const result = await this.aadGet<IJSPage>(apiUrl);
    return result;
  }

  public async getPageDataAsync(formVersionId: Guid, itemId: string | number): Promise<IDictionary<any>> {
    const apiUrl = `${Sede.Shared.ProcesoxUrl}/pages/${formVersionId}/data?itemId=${itemId}`;
    const result = await this.aadGet<IDictionary<any>>(apiUrl);
    return result;
  }

}

export function initSdk(): void {
  const tmp = (window as any).__ioip__sdk__ || (window as any).__global;
  if (tmp !== undefined && typeof tmp === 'function') {
    $_ = tmp();
  } else {
    $_.props = {
      appId: '',
      cssStyles: '',
      headerImage: '',
      icon: '',
      nombre: 'IOIP SDK',
      tenantId: '',
      title: 'IOIP SDK'
    };
    $_.svc = defaultIAppServices();
    $_.confirmationDialog = (title: string, text: string, callback: (() => void) | (() => Promise<void>)) => {
      if (window.confirm(text)) {
        callback();
      }
    }
  }
}

export function defaultIValorMetadato(): IValorMetadato {
  return {
    IdValorMetadato: 0,
    IdExpediente: 0,
    IdDocumentoExpediente: 0,
    IdMetadato: 0,
    Valor: '',
    IdOpcionListaDesplegableMetadato: 0,
    Nombre: '',
    Codigo: '',
    CategoriaMetadato: ''
  }
}

export const createOptions = function createOptions<T>(items: T[], keySelector: (item: T) => number | string, textSelector: (item: T) => string): IComboBoxOption[] {
  return items.map(x => ({ key: keySelector(x), text: textSelector(x) }));
}